import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import io from 'socket.io-client';
import Select from 'react-select';
import { Line,Doughnut, Bar, Pie, Scatter } from 'react-chartjs-2';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ProgressBar } from "react-bootstrap";
import GaugeChart from 'react-gauge-chart';
import { useLocation } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import 'react-datepicker/dist/react-datepicker.css';
import Picker from 'emoji-picker-react'; 
import axios from 'axios';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import Compressor from 'compressorjs';
import "chart.js/auto";
import Calendar from "react-calendar";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import html2canvas from "html2canvas";
import { v4 as uuidv4 } from 'uuid'; 
import polyline from '@mapbox/polyline';
import moment from 'moment';



import styles from '../../styles/UltimatePage.module.css';
import Loader from '../../shared/Loader'; // Importă componenta Loader
import Notifications from '../../shared/NotificationsSettings';
import ChartMenu from '../../shared/ChartMenu';
import TwoFactorNotification from '../../shared/TwoFactorNotification';
import LoadsNotifications from '../../shared/LoadsNotifications';
import DriversNotifications from '../../shared/DriverNotifications';
import DeleteNotifications from '../../shared/DeleteNotifications';
import { PDFDownloadLink, PDFViewer, Document, Page, Text, View } from '@react-pdf/renderer';
import { pdf } from '@react-pdf/renderer';
import {
  Chart as ChartJS,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  ArcElement
} from 'chart.js';
import {
  BarChart,
  XAxis,
  YAxis,
  LineChart,
  
  CartesianGrid,
  PieChart,
  
  Cell
} from "recharts";
import { GoogleMap, LoadScript, Marker, Polyline, Circle } from '@react-google-maps/api';
import { Chart, registerables } from "chart.js";

// Înregistrăm ArcElement împreună cu celelalte elemente
ChartJS.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend,
  Title
);
axios.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
const socket = io('https://api-backend.full-trucking-service.com', {
  transports: ['websocket', 'polling'],
  secure: true, // Asigură conexiuni securizate în mediul de producție
  reconnect: true, // Activează reconectarea automată în cazul întreruperii
  timeout: 20000, // Timpul maxim de conectare înainte de timeout (în milisecunde)
  reconnectionAttempts: 5, // Numărul de încercări de reconectare înainte de a renunța
  reconnectionDelay: 1000, // Întârziere între reconectări (în milisecunde)
  rejectUnauthorized: false, // Permite conexiuni securizate fără a respinge cererile nesemnate
});



const apiUrl = process.env.REACT_APP_API_URL || 'https://api-backend.full-trucking-service.com/api';

const StandartPage = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('add-new-load'); 
  const [lastInteractionTime, setLastInteractionTime] = useState(Date.now());
  const inactivityTimeoutRef = useRef(null);
  const refreshOnNextInteractionRef = useRef(false);
  const [selectedLoadId, setSelectedLoadId] = useState(null);
  const [userSettings, setUserSettings] = useState({});
  const [drivers, setDrivers] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [trailers, setTrailers] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [shippers, setShippers] = useState([]);
  const [consignees, setConsignees] = useState([]);
  const [loads, setLoads] = useState([]);
  const [driverPays, setDriverPays] = useState([]);
  const [loadNumber, setLoadNumber] = useState('');
  const [dispatcher, setDispatcher] = useState('');
  const [brokerName, setBrokerName] = useState('');
  const [brokerAddress, setBrokerAddress] = useState('');
  const [rate, setRate] = useState('');
  const [equipment, setEquipment] = useState('');
  const [driver, setDriver] = useState('');
  const [truck, setTruck] = useState('');
  const [trailer, setTrailer] = useState('');
  const [status, setStatus] = useState('');
  const [shipperName, setShipperName] = useState('');
  const [shipperAddress, setShipperAddress] = useState('');
  const [consigneeName, setConsigneeName] = useState('');
  const [consigneeAddress, setConsigneeAddress] = useState('');
  const [miles, setMiles] = useState('');
  const [dh, setDH] = useState('');
  const [notes, setNotes] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [messages, setMessages] = useState([]);
  const [startDate, setStartDate] = useState('');  // Definim startDate
  const [endDate, setEndDate] = useState('');  
  const [loading, setLoading] = useState(false);
  const [dispatchers, setDispatchers] = useState([]); // Definește `dispatchers`
  const [currentUserId, setCurrentUserId] = useState(null); // Definește `currentUserId`
  const [currentUserRole, setCurrentUserRole] = useState(null); // Definește `currentUserRole`
  const [hasTwoFactorAuth, setHasTwoFactorAuth] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const location = useLocation(); // Inițializează useLocation
  const userRole = location.state?.role || 'client'; // Setează 'client' ca rol implicit
  const [isLoading, setIsLoading] = useState(true); // Stare pentru controlul procesului de încărcare
  const [isInitialized, setIsInitialized] = useState(false); // Controlăm complet procesul de inițializare
  const [isTwoFactorEnabled, setIsTwoFactorEnabled] = useState(false);
  const [twoFactorWarning, setTwoFactorWarning] = useState(false);
  const [isInteractionAllowed, setIsInteractionAllowed] = useState(false);
  const [unreadMessages, setUnreadMessages] = useState(() => {
    const savedUnread = localStorage.getItem("unreadMessages");
    return savedUnread ? JSON.parse(savedUnread) : {};
  });
  const audioRef = useRef(null);
  
  const getToken = () => {
    return sessionStorage.getItem('token') || localStorage.getItem('token');
  };
  
  const socketRef = useRef(null);
  const clientId = localStorage.getItem('clientId');
  const [newMessageNotification, setNewMessageNotification] = useState(null);

// 🔥 Funcție pentru afișarea notificării vizuale
const showNewMessageNotification = (data) => {
  setNewMessageNotification(`${data.sender}: ${data.message}`);

  setTimeout(() => {
    setNewMessageNotification(null);
  }, 5000); // 🔥 Se ascunde după 5 secunde
};


  const handleNavigateToSection = (section, loadId = null) => {
    setActiveSection(section);
    setSelectedLoadId(loadId); // Setăm `loadId` pentru secțiunea `LoadManager`
  };

  const savedPermissions = JSON.parse(localStorage.getItem('permissions')) || [];

  const accessibleModules = savedPermissions && savedPermissions.length > 0 
    ? savedPermissions // ✅ Folosește permisiunile reale
    : userRole === 'client' 
      ? [
        'accounting-manager', 'driver-pay', 'ifta', 
        'drivers', 'trucks', 'trailers', 'brokers', 'shippers', 
        'consignees', 'load-manager', 'load-finder', 'trucking', 
        'chat', 'settings', 'add-new-load'
      ] 
      : [];
  
    const queryParams = new URLSearchParams(window.location.search);
    const activeTab = queryParams.get('tab') || 'default'; // Default poate fi un alt tab implicit.
  

    useEffect(() => {
      if (activeTab === 'add-new-load') {
        setActiveSection('add-new-load');
      }
    }, [activeTab]);
  
    useEffect(() => {
      if (activeSection === 'settings' && !isTwoFactorEnabled) {
        const element = document.querySelector('.twoFactorWarningsettings');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }, [activeSection, isTwoFactorEnabled]);
    

    useEffect(() => {
      const resetInactivityTimer = () => {
        setLastInteractionTime(Date.now());
  
        if (refreshOnNextInteractionRef.current) {
          refreshOnNextInteractionRef.current = false;
          window.location.reload();
        }
  
        if (inactivityTimeoutRef.current) {
          clearTimeout(inactivityTimeoutRef.current);
        }
  
        inactivityTimeoutRef.current = setTimeout(() => {
          refreshOnNextInteractionRef.current = true;
        }, 10 * 60 * 1000); // 10 minute
      };
  
      document.addEventListener("mousemove", resetInactivityTimer);
      document.addEventListener("keydown", resetInactivityTimer);
      document.addEventListener("scroll", resetInactivityTimer);
      document.addEventListener("click", resetInactivityTimer);
  
      return () => {
        document.removeEventListener("mousemove", resetInactivityTimer);
        document.removeEventListener("keydown", resetInactivityTimer);
        document.removeEventListener("scroll", resetInactivityTimer);
        document.removeEventListener("click", resetInactivityTimer);
  
        if (inactivityTimeoutRef.current) {
          clearTimeout(inactivityTimeoutRef.current);
        }
      };
    }, []);

    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const tokenExpiration = localStorage.getItem('tokenExpiration');
    
        if (!token || !tokenExpiration || new Date() >= new Date(tokenExpiration)) {
          alert('Session expired. Please log in again.');
          navigate('/login');
          return;
        }
    
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        };
    
        const [
          userSettingsRes,
          driversRes,
          trucksRes,
          trailersRes,
          brokersRes,
          shippersRes,
          consigneesRes,
          loadsRes,
          driverPaysRes,
          iftaReportsRes,
        ] = await Promise.all([
          axios.get(`${apiUrl}/settings`, config),
          axios.get(`${apiUrl}/drivers`, config),
          axios.get(`${apiUrl}/trucks`, config),
          axios.get(`${apiUrl}/trailers`, config),
          axios.get(`${apiUrl}/brokers`, config),
          axios.get(`${apiUrl}/shippers`, config),
          axios.get(`${apiUrl}/consignees`, config),
          axios.get(`${apiUrl}/loads`, config),
          axios.get(`${apiUrl}/driverpays`, config),
          axios.get(`${apiUrl}/ifta`, config),
        ]);
    
        setUserSettings(userSettingsRes.data);
        setDrivers(driversRes.data);
        setTrucks(trucksRes.data);
        setTrailers(trailersRes.data);
        setBrokers(brokersRes.data);
        setShippers(shippersRes.data);
        setConsignees(consigneesRes.data);
        setLoads(loadsRes.data);
        setDriverPays(driverPaysRes.data);
    
        
      } catch (error) {
        console.error('Error fetching data:', error);
        alert('Failed to fetch data. Please try again later.');
      }
    };
    useEffect(() => {
      const fetchTwoFactorAuthStatus = async () => {
        const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    
        if (!token) {
          console.error('No token found in sessionStorage or localStorage');
          setHasTwoFactorAuth(false); // Presupunem că 2FA nu este activat
          setIsInitialized(true); // Marcam inițializarea ca fiind completă
          return;
        }
    
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        };
    
        try {
          const response = await axios.get(`${apiUrl}/settings`, config);
          const settings = response.data;
    
          if (settings && typeof settings.twoFactorAuthEnabled === 'boolean') {
            setHasTwoFactorAuth(settings.twoFactorAuthEnabled);
          } else {
            console.warn('Invalid response format or missing twoFactorAuthEnabled field');
            setHasTwoFactorAuth(false); // Implicit presupunem că 2FA nu este activat
          }
        } catch (error) {
          console.error('Error fetching 2FA status:', error);
          setHasTwoFactorAuth(false); // Implicit presupunem că 2FA nu este activat
        } finally {
          setIsInitialized(true); // Marcam inițializarea ca fiind completă
        }
      };
    
      fetchTwoFactorAuthStatus();
    }, [apiUrl]);
    
    useEffect(() => {
      const enableAudio = () => setIsInteractionAllowed(true);
      document.addEventListener("click", enableAudio);
      return () => document.removeEventListener("click", enableAudio);
    }, []);
    
    useEffect(() => {
      if (unreadMessages.length > 0 && isInteractionAllowed) {
        audioRef.current.play().catch((err) => console.error("🔇 Audio playback error:", err));
      }
    }, [unreadMessages]);
    
  const handleSendMessage = (message) => {
    if (message.trim() !== '') {
      setMessages((prevMessages) => [
        ...prevMessages,
        { from: 'me', message },
      ]);
    }
  };

  useEffect(() => {
    const socket = io("https://api-backend.full-trucking-service.com", {
      transports: ["websocket"],
      extraHeaders: { Authorization: `Bearer ${getToken()}` },
    });
  
    socket.on("connect", () => {
      console.log("✅ Connected to WebSocket");
      socket.emit("registerClient", { clientId });
    });
  
    socket.on("receiveMessage", (data) => {
      console.log("📩 Mesaj nou primit:", data);
  
      setUnreadMessages((prev) => {
        const updated = {
          ...prev,
          [data.driverId]: (prev[data.driverId] || 0) + 1,
        };
        localStorage.setItem("unreadMessages", JSON.stringify(updated));
        return updated;
      });
    });
  
    return () => socket.disconnect();
  }, [clientId]);
  

  useEffect(() => {
    localStorage.setItem("unreadMessages", JSON.stringify(unreadMessages));
  }, [unreadMessages]);


  useEffect(() => {
    // Exemplu de apel API pentru a obține dispatchers și datele utilizatorului
    const fetchData = async () => {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token'); // Obține token-ul de autentificare
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`, // Include token-ul cu prefixul Bearer
          'Content-Type': 'application/json',
        },
        withCredentials: true, // Permite trimiterea cookie-urilor pentru autentificare
      };
    
      try {
        // Apel pentru a obține lista de dispatchers
        const dispatchersData = await axios.get('https://api-backend.full-trucking-service.com/api/dispatchers', config);
        setDispatchers(dispatchersData.data);
    
        // Apel pentru a obține datele utilizatorului curent
        const userData = await axios.get('https://api-backend.full-trucking-service.com/api/current-user', config);
        setCurrentUserId(userData.data.id);
        setCurrentUserRole(userData.data.role);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  
  useEffect(() => {
    fetchData();
  }, []);
  const handleUpdateDriver = async (updatedDriver) => {
    try {
      const response = await axios.put(`${apiUrl}/drivers/${updatedDriver._id}`, updatedDriver, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });
  
      if (!response || response.status !== 200) {
        throw new Error('Failed to update driver');
      }
  
      const updatedData = response.data;
      setDrivers((prevDrivers) =>
        prevDrivers.map((driver) => (driver._id === updatedDriver._id ? updatedData : driver))
      );
      alert('Driver information has been updated successfully!');
    } catch (error) {
      console.error('Error updating driver:', error);
      alert('Failed to update driver');
    }
  };
  const openSection = (section) => {
    setTimeout(() => {
      setActiveSection(section);
    }, 1000);
  };
  
  
   
  const closeSection = () => setActiveSection(null);

  const handleLogout = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://api-backend.full-trucking-service.com/api';
  
      // Trimite cererea de logout către backend
      await axios.post(`${apiUrl}/logout`, {}, { withCredentials: true });
  
      // Șterge datele utilizatorului stocate local
      localStorage.removeItem('token');
      localStorage.removeItem('tokenExpiration');
      localStorage.removeItem('clientId');
      localStorage.removeItem('clientPackage');
      localStorage.removeItem('role');
  
      // Navighează utilizatorul înapoi la pagina de login
      navigate('/login');
    } catch (error) {
      console.error('Error during logout:', error);
      alert('An error occurred while logging out. Please try again.');
    }
  };
  

  const updateUserSettings = async (settings) => {
    setLoading(true); // Pornește animația
    
    const token = sessionStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    };
  
    try {
      const response = await axios.put(`${apiUrl}/settings`, settings, config);
      setUserSettings(response.data);
      alert('Settings updated successfully!');
    } catch (error) {
      console.error('Error updating user settings:', error);
      if (error.response && error.response.status === 401) {
        alert('Unauthorized access. Please log in again.');
        navigate('/login');
      }
    } finally {
      setLoading(false); // Oprește animația după finalizarea cererii
    }
  };
  
  useEffect(() => {
    const socket = io("https://api-backend.full-trucking-service.com", {
      transports: ["websocket"],
      extraHeaders: { Authorization: `Bearer ${getToken()}` },
    });
    socketRef.current = socket;

    socket.on("connect", () => {
      console.log("✅ Connected to WebSocket");
      socket.emit("registerClient", { clientId });
    });

    socket.on("receiveMessage", (data) => {
      console.log("📩 Mesaj nou primit:", data);
    
      if (!selectedDriver || selectedDriver._id !== data.driverId) {
        setUnreadMessages((prev) => (Array.isArray(prev) ? [...prev, data] : [data]));
    
        // 🔊 Redă notificarea sonoră doar după interacțiunea utilizatorului
        if (audioRef.current) {
          const playPromise = audioRef.current.play();
          if (playPromise !== undefined) {
            playPromise.catch((error) => {
              console.warn("🔇 Browser blocked autoplay. Waiting for user interaction.");
            });
          }
        }
      }
    });
    
    return () => socket.disconnect();
  }, [clientId, selectedDriver]);


  
  // 🔥 Funcție pentru a marca mesajele ca citite când deschizi chatul unui șofer
  const markMessagesAsRead = (driverId) => {
    setUnreadMessages((prev) => prev.filter((msg) => msg.driverId !== driverId));
  };

  const handleAddLoad = async (load) => {
    try {
        if (!load.loadNumber || !load.brokerName || !load.brokerAddress || !load.rate || !load.miles || !load.dh) {
            alert('Please fill in all required fields.');
            return;
        }

        // Elimina virgula și convertește rate într-un număr
        const cleanedRate = parseFloat(load.rate.replace(/,/g, ''));
        
        const loadData = {
            ...load,
            rate: cleanedRate,  // Asigură-te că `rate` este un număr
            miles: parseFloat(load.miles), // Adaugă miles și convertește în număr
            dh: parseFloat(load.dh), // Adaugă dh și convertește în număr
        };

        const config = { headers: { 'Content-Type': 'application/json' }, withCredentials: true };
        const response = await axios.post(`${apiUrl}/loads`, loadData, config);

        setLoads([...loads, response.data]);
    } catch (error) {
        console.error('Error adding load:', error);
    }
};

  
  
  
const handleAddDriverPay = async (driverPayData) => {
  try {
    const response = await axios.post('https://api-backend.full-trucking-service.com/api/driverpays', driverPayData, {
      withCredentials: true, // Dacă folosești autentificare
    });
    console.log('Driver pay added:', response.data);
  } catch (error) {
    console.error('Error adding driver pay:', error);
  }
};


return (
  <div className={styles.ultimatePage}>
    <header className={styles.headerultimatePage}>
      <div className={styles.logoultimatePage} onClick={() => navigate('')}>
        <span className={styles.logoPart1ultimatePage}>Full</span>{' '}
        <span className={styles.logoPart2ultimatePage}>Trucking</span>{' '}
        <span className={styles.logoPart1ultimatePage}>Service</span>
      </div>
      <nav className={styles.navultimatePage}>
        <ul className={styles.mainMenuultimatePage}>
      
          {accessibleModules.includes('accounting-manager') && (
            <li>
              Finance
              <ul className={styles.subMenuultimatePage}>
                <li onClick={() => openSection('driver-pay')}>Payroll</li>
                <li onClick={() => openSection('driverpay-manager')}>Payroll Manager</li>
                <li onClick={() => openSection('fuel-report')}>Fuel Report</li>
               
              </ul>
            </li>
          )}
          {accessibleModules.includes('drivers') && (
            <li>
              Operations
              <ul className={styles.subMenuultimatePage}>
                <li onClick={() => openSection('drivers')}>Drivers</li>
                <li onClick={() => openSection('trucks')}>Fleet</li>
                <li onClick={() => openSection('trailers')}>Trailers</li>
                <li onClick={() => openSection('shippers')}>Shippers</li>
                <li onClick={() => openSection('consignee')}>Consignees</li>
                <li onClick={() => openSection('brokers')}>Brokers</li>
         
              </ul>
            </li>
          )}
          {accessibleModules.includes('load-manager') && (
            <li>
              Logistics
              <ul className={styles.subMenuultimatePage}>
                <li onClick={() => openSection('load-manager')}>Load Scheduler</li>
                <li onClick={() => openSection('load-finder')}>Load Tracker</li>
              </ul>
            </li>
          )}
          

          {accessibleModules.includes('settings') && <li onClick={() => openSection('settings')}>Settings</li>}
          {accessibleModules.includes('add-new-load') && (
            <li>
              <button className={styles.buttonultimatePage} onClick={() => openSection('add-new-load')}>
                Load Entry
              </button>
            </li>
          )}
          <li>
            <button className={styles.buttonultimatePage} onClick={handleLogout}>Logout</button>
          </li>
        </ul>
      </nav>
    </header>

    {/* 🔊 Notificare audio */}
    <audio ref={audioRef} src="/notification.mp3" preload="auto"></audio>
  
   {/* Notificarea pentru 2FA */}
{isInitialized && !hasTwoFactorAuth && (
  <TwoFactorNotification 
    hasTwoFactorAuth={hasTwoFactorAuth}
    onNavigateToSection={handleNavigateToSection}
  />)}

{isInitialized && (
  <LoadsNotifications
    initialDelay={10000} // Prima notificare la 10 secunde
    intervalDelay={2 * 60 * 1000} // Notificare la fiecare 2 minute
    hideAfter={5000}  
    resetDelay={24 * 60 * 60 * 1000} // Fără notificări repetate timp de 24h
    onNavigateToSection={(section, loadId) => {
      navigate(`/${section}/${loadId}`);
    }}
  />
)}

<DriversNotifications
  initialDelay={15000} // Prima notificare după 15 secunde
  intervalDelay={2 * 60 * 1000} // Notificare la fiecare 2 minute
  resetDelay={24 * 60 * 60 * 1000} // O notificare per șofer la fiecare 24 de ore
/>


    <main>
 
      {activeSection === 'drivers' && <Drivers drivers={drivers} setDrivers={setDrivers} trucks={trucks} />}
      {activeSection === 'trucks' && <Trucks trucks={trucks} setTrucks={setTrucks} drivers={drivers} trailers={trailers} />}
      {activeSection === 'trailers' && <Trailers trailers={trailers} setTrailers={setTrailers} />}
      {activeSection === 'brokers' && <Brokers brokers={brokers} setBrokers={setBrokers} />}
      {activeSection === 'shippers' && <Shippers shippers={shippers} setShippers={setShippers} />}
      {activeSection === 'consignee' && <Consignees consignees={consignees} setConsignees={setConsignees} />}
      {activeSection === 'load-manager' && (
        <LoadManager
          loads={loads}
          setLoads={setLoads}
          selectedLoadId={selectedLoadId} // Transmitem loadId-ul selectat
        />
      )}
   
      {activeSection === 'load-finder' && <LoadFinder loads={loads} />}
      {activeSection === 'driver-pay' && <DriverPay drivers={drivers} trucks={trucks} loads={loads} onAddDriverPay={handleAddDriverPay} />}
      {activeSection === 'driverpay-manager' && <DriverPayManager drivers={drivers} trucks={trucks}  />}
      {activeSection === 'fuel-report' && <FuelReport drivers={drivers} trucks={trucks} />}
  
      {activeSection === 'settings' && <Settings settings={userSettings} updateUserSettings={updateUserSettings} drivers={drivers} />}
      {activeSection === 'add-new-load' && <AddLoad
  onClose={closeSection}
  onAddLoad={handleAddLoad}
  drivers={drivers}
  trucks={trucks}
  trailers={trailers}
  brokers={brokers}
  shippers={shippers}
  consignees={consignees}
  dispatchers={dispatchers} // Asigură-te că `dispatchers` este definit în componenta principală
  currentUserId={currentUserId} // Obține `currentUserId` și `currentUserRole` din starea sau props
  currentUserRole={currentUserRole}
/>
}      {activeSection === 'ifta' && <IFTA />}
 
     

    </main>
  </div>
);
};

const Drivers = ({ drivers = [], setDrivers, trucks = [] }) => {
  const [limits, setLimits] = useState({ numberOfDrivers: 0 });
  const [selectedDriver, setSelectedDriver] = useState(null); // Stochează șoferul selectat
  const [driverData, setDriverData] = useState({
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    hireDate: '',
    truckNumber: '',
    email: '',
    mobilePhone: '',
    phone: '',
    address: '',
    licenseNumber: '',
    licenseExpiryDate: '',
    passportExpiryDate: '',
    lastMedical: '',
    nextMedical: '',
    lastDrugTest: '',
    lastAlcoholTest: '',
    fuelCardNumber: '',
    fuelCardExpiryDate: '',
    fleetDivision: '',
    settlement: '',
    settlementAmount: '',
    licenseType: '',
    licenseState: '',
    emergencyContactFirstName: '',
    emergencyContactLastName: '',
    emergencyContactRelation: '',
    emergencyContactPhone: '',
    employeeRecordsChecklist: {
      copyOfLicense: false,
      preEmploymentDrugTest: false,
      longMedicalForm: false,
      copyOfRoadTest: false,
      enrolledInDrugTestingProgram: false,
      certificateOfCompliance: false,
      inquiryToPreviousEmployers: false,
      nonMotorCarrierActivityForm: false,
      inquiryToStateAgencies: false,
      proofOfReceivingFMCSRHandbook: false,
    },
    annualCertificationOfViolations: '',
    employmentApplication: '',
    annualMVRReview: '',
    internalNotes: '',
    notes: '',
  });

  const apiUrl = 'https://api-backend.full-trucking-service.com/api'; 
  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [licenseExpired, setLicenseExpired] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);



  const token = sessionStorage.getItem('token'); 
  const clientId = localStorage.getItem('clientId'); 
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    withCredentials: true,
  };

  useEffect(() => {
    const fetchDriverLimit = async () => {
      try {
        const response = await axios.get(`${apiUrl}/clients`, config);
        setLimits({
          numberOfDrivers: response.data.numberOfDrivers,
        });
      } catch (error) {
        console.error('Error fetching driver limit:', error);
      }
    };
    
    fetchDriverLimit();
  }, []);

  const fetchDrivers = async () => {
    try {
      const response = await axios.get(`${apiUrl}/drivers`, config);
      setDrivers(response.data);
    } catch (error) {
      console.error('Error fetching drivers:', error);
    }
  };

  useEffect(() => {
    fetchDrivers();
  }, []);

  const fetchNotMoreWorkingDrivers = async () => {
    try {
        const response = await axios.get(`${apiUrl}/drivers/notMoreWorking`, config);
        setDrivers(response.data);
    } catch (error) {
        console.error('Error fetching not working drivers:', error);
    }
};
const handleViewDriverDetails = async (driverId) => {
  try {
      const response = await axios.get(`${apiUrl}/drivers/${driverId}`, config);
      setSelectedDriver(response.data);
  } catch (error) {
      console.error('Error fetching driver details:', error);
  }
};


  useEffect(() => {
    if (driverData.licenseExpiryDate) {
      const today = new Date().toISOString().split('T')[0];
      setLicenseExpired(driverData.licenseExpiryDate < today);
    }
  }, [driverData.licenseExpiryDate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDriverData({ ...driverData, [name]: value });
  };

  const handleCheckboxChange = (e, field) => {
    const [section, fieldName] = field.split('.');
    if (section === 'employeeRecordsChecklist') {
      setDriverData({
        ...driverData,
        employeeRecordsChecklist: {
          ...driverData.employeeRecordsChecklist,
          [fieldName]: e.target.checked,
        },
      });
    } else {
      setDriverData({ ...driverData, [field]: e.target.checked });
    }
  };

  const handleSettlementChange = (e) => {
    const selectedSettlement = e.target.value;
    
    // Resetăm câmpurile în funcție de metoda selectată
    const resetData = {
      normalMileRate: selectedSettlement === 'Per mile pay' ? driverData.normalMileRate : undefined,
      dhMileRate: selectedSettlement === 'Per mile pay' ? driverData.dhMileRate : undefined,
      hourlyRate: selectedSettlement === 'Hourly pay' ? driverData.hourlyRate : undefined,
      hoursWorked: selectedSettlement === 'Hourly pay' ? driverData.hoursWorked : undefined,
      teamDriver: selectedSettlement === 'Team driver pay' ? driverData.teamDriver : undefined,
      teamPercentage: selectedSettlement === 'Team driver pay' ? driverData.teamPercentage : undefined,
      settlementAmount: selectedSettlement !== 'Per mile pay' && selectedSettlement !== 'Hourly pay' ? driverData.settlementAmount : undefined,
    };
  
    setDriverData({
      ...driverData,
      settlement: selectedSettlement,
      ...resetData,
    });
  };
  

  const handleSubmit = async () => {
    if (editingIndex === null && drivers.length >= limits.numberOfDrivers) {
      alert('Nu poți adăuga mai mulți șoferi decât limita stabilită.');
      return;
    }
  
    const dataToSend = {
      ...(driverData.firstName && { firstName: driverData.firstName.trim() }),
      ...(driverData.lastName && { lastName: driverData.lastName.trim() }),
      ...(driverData.email && { email: driverData.email.trim() }),
      ...(driverData.phone && { phone: driverData.phone.trim() }),
      ...(driverData.address && { address: driverData.address.trim() }),
      ...(driverData.licenseNumber && { licenseNumber: driverData.licenseNumber.trim() }),
      ...(driverData.licenseExpiryDate && { licenseExpiryDate: driverData.licenseExpiryDate }),
      ...(driverData.lastDrugTestDate && { lastDrugTestDate: driverData.lastDrugTestDate }),
      ...(driverData.truckNumber && { truckNumber: driverData.truckNumber.trim() }),
      ...(driverData.settlement && { settlement: driverData.settlement.trim() }),
      ...(driverData.settlementAmount && { settlementAmount: Number(driverData.settlementAmount) }),
      ...(driverData.hourlyRate && { hourlyRate: Number(driverData.hourlyRate) }),
      ...(driverData.hoursWorked && { hoursWorked: Number(driverData.hoursWorked) }),
      ...(driverData.normalMileRate && { normalMileRate: Number(driverData.normalMileRate) }),
      ...(driverData.dhMileRate && { dhMileRate: Number(driverData.dhMileRate) }),
      ...(driverData.dateOfBirth && { dateOfBirth: driverData.dateOfBirth }),
      ...(driverData.hireDate && { hireDate: driverData.hireDate }),
      ...(driverData.terminationDate && { terminationDate: driverData.terminationDate }),
      ...(driverData.licenseType && { licenseType: driverData.licenseType.trim() }),
      ...(driverData.licenseState && { licenseState: driverData.licenseState.trim() }),
      ...(driverData.passportExpires && { passportExpires: driverData.passportExpires }),
      ...(driverData.medicalInfo?.lastMedical && { "medicalInfo.lastMedical": driverData.medicalInfo.lastMedical }),
      ...(driverData.medicalInfo?.nextMedical && { "medicalInfo.nextMedical": driverData.medicalInfo.nextMedical }),
      ...(driverData.medicalInfo?.lastAlcoholTest && { "medicalInfo.lastAlcoholTest": driverData.medicalInfo.lastAlcoholTest }),
      ...(driverData.corporateInfo?.fuelCardNumber && { "corporateInfo.fuelCardNumber": driverData.corporateInfo.fuelCardNumber }),
      ...(driverData.corporateInfo?.fuelCardExpires && { "corporateInfo.fuelCardExpires": driverData.corporateInfo.fuelCardExpires }),
      ...(driverData.corporateInfo?.fleetDivision && { "corporateInfo.fleetDivision": driverData.corporateInfo.fleetDivision }),
      ...(driverData.checklist?.copyOfLicense && { "checklist.copyOfLicense": driverData.checklist.copyOfLicense }),
      ...(driverData.checklist?.preEmploymentDrugTest && { "checklist.preEmploymentDrugTest": driverData.checklist.preEmploymentDrugTest }),
      ...(driverData.checklist?.longMedicalForm && { "checklist.longMedicalForm": driverData.checklist.longMedicalForm }),
      ...(driverData.checklist?.proofOfReceivingFMCSR && { "checklist.proofOfReceivingFMCSR": driverData.checklist.proofOfReceivingFMCSR }),
      ...(driverData.recurringDeductions && { recurringDeductions: driverData.recurringDeductions }),
      ...(driverData.recurringAdditions && { recurringAdditions: driverData.recurringAdditions }),
      ...(driverData.annualCertificationOfViolations && { annualCertificationOfViolations: driverData.annualCertificationOfViolations }),
      ...(driverData.employmentApplication && { employmentApplication: driverData.employmentApplication }),
      ...(driverData.annualMVRReview && { annualMVRReview: driverData.annualMVRReview }),
      ...(driverData.internalNotes && { internalNotes: driverData.internalNotes }),
      ...(driverData.notes && { notes: driverData.notes }),
      clientId,
    };
  
    console.log('Sending data to backend:', dataToSend);
  
    try {
      if (editingIndex !== null) {
        const driverId = drivers[editingIndex]._id;
        const response = await axios.put(`${apiUrl}/drivers/${driverId}`, dataToSend, config);
  
        if (response.status === 200) {
          const updatedDriver = response.data.driver;
          setDrivers((prevDrivers) =>
            prevDrivers.map((driver, index) => (index === editingIndex ? updatedDriver : driver))
          );
          alert('Driver updated successfully!');
        } else {
          console.error('Failed to update driver:', response.data.error);
          alert(response.data.error || 'Failed to update driver.');
        }
      } else {
        const response = await axios.post(`${apiUrl}/drivers`, dataToSend, config);
  
        if (response.status === 201) {
          setDrivers((prevDrivers) => [...prevDrivers, response.data.driver]);
          alert('Driver added successfully!');
        } else {
          console.error('Failed to add driver:', response.data.error);
          alert(response.data.error || 'Failed to add driver.');
        }
      }
  
      // Reset form data
      setDriverData({
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        hireDate: '',
        truckNumber: '',
        email: '',
        mobilePhone: '',
        phone: '',
        address: '',
        licenseNumber: '',
        licenseExpiryDate: '',
        passportExpiryDate: '',
        lastMedical: '',
        nextMedical: '',
        lastDrugTest: '',
        lastAlcoholTest: '',
        fuelCardNumber: '',
        fuelCardExpiryDate: '',
        fleetDivision: '',
        settlement: '',
        settlementAmount: '',
        licenseType: '',
        licenseState: '',
        emergencyContactFirstName: '',
        emergencyContactLastName: '',
        emergencyContactRelation: '',
        emergencyContactPhone: '',
        employeeRecordsChecklist: {
          copyOfLicense: false,
          preEmploymentDrugTest: false,
          longMedicalForm: false,
          copyOfRoadTest: false,
          enrolledInDrugTestingProgram: false,
          certificateOfCompliance: false,
          inquiryToPreviousEmployers: false,
          nonMotorCarrierActivityForm: false,
          inquiryToStateAgencies: false,
          proofOfReceivingFMCSRHandbook: false,
        },
        annualCertificationOfViolations: '',
        employmentApplication: '',
        annualMVRReview: '',
        internalNotes: '',
        notes: '',
      });
  
      setEditingIndex(null);
    } catch (error) {
      console.error('Error saving driver:', error.response?.data || error.message);
      alert(error.response?.data?.error || 'Failed to save driver. Please try again.');
    }
  };
  

  const handleEdit = (index) => {
    const driverToEdit = drivers[index];
  
    // Asigură-te că `employeeRecordsChecklist` și alte câmpuri există
    const updatedDriverData = {
      firstName: driverToEdit.firstName || '',
      lastName: driverToEdit.lastName || '',
      dateOfBirth: driverToEdit.dateOfBirth || '',
      hireDate: driverToEdit.hireDate || '',
      truckNumber: driverToEdit.truckNumber || '',
      email: driverToEdit.email || '',
      mobilePhone: driverToEdit.mobilePhone || '',
      phone: driverToEdit.phone || '',
      address: driverToEdit.address || '',
      licenseNumber: driverToEdit.licenseNumber || '',
      licenseExpiryDate: driverToEdit.licenseExpiryDate || '',
      passportExpiryDate: driverToEdit.passportExpiryDate || '',
      lastMedical: driverToEdit.lastMedical || '',
      nextMedical: driverToEdit.nextMedical || '',
      lastDrugTest: driverToEdit.lastDrugTest || '',
      lastAlcoholTest: driverToEdit.lastAlcoholTest || '',
      fuelCardNumber: driverToEdit.fuelCardNumber || '',
      fuelCardExpiryDate: driverToEdit.fuelCardExpiryDate || '',
      fleetDivision: driverToEdit.fleetDivision || '',
      settlement: driverToEdit.settlement || '',
      settlementAmount: driverToEdit.settlementAmount || '',
      licenseType: driverToEdit.licenseType || '',
      licenseState: driverToEdit.licenseState || '',
      emergencyContactFirstName: driverToEdit.emergencyContactFirstName || '',
      emergencyContactLastName: driverToEdit.emergencyContactLastName || '',
      emergencyContactRelation: driverToEdit.emergencyContactRelation || '',
      emergencyContactPhone: driverToEdit.emergencyContactPhone || '',
      employeeRecordsChecklist: {
        copyOfLicense: driverToEdit.employeeRecordsChecklist?.copyOfLicense || false,
        preEmploymentDrugTest: driverToEdit.employeeRecordsChecklist?.preEmploymentDrugTest || false,
        longMedicalForm: driverToEdit.employeeRecordsChecklist?.longMedicalForm || false,
        copyOfRoadTest: driverToEdit.employeeRecordsChecklist?.copyOfRoadTest || false,
        enrolledInDrugTestingProgram: driverToEdit.employeeRecordsChecklist?.enrolledInDrugTestingProgram || false,
        certificateOfCompliance: driverToEdit.employeeRecordsChecklist?.certificateOfCompliance || false,
        inquiryToPreviousEmployers: driverToEdit.employeeRecordsChecklist?.inquiryToPreviousEmployers || false,
        nonMotorCarrierActivityForm: driverToEdit.employeeRecordsChecklist?.nonMotorCarrierActivityForm || false,
        inquiryToStateAgencies: driverToEdit.employeeRecordsChecklist?.inquiryToStateAgencies || false,
        proofOfReceivingFMCSRHandbook: driverToEdit.employeeRecordsChecklist?.proofOfReceivingFMCSRHandbook || false,
      },
      annualCertificationOfViolations: driverToEdit.annualCertificationOfViolations || '',
      employmentApplication: driverToEdit.employmentApplication || '',
      annualMVRReview: driverToEdit.annualMVRReview || '',
      internalNotes: driverToEdit.internalNotes || '',
      notes: driverToEdit.notes || '',
    };
  
    setDriverData(updatedDriverData);
    setEditingIndex(index);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  

  const confirmDeleteDriver = async (index) => {
    try {
      const driverId = drivers[index]._id;
      await axios.delete(`${apiUrl}/drivers/${driverId}`, config);
      setDrivers((prevDrivers) => prevDrivers.filter((_, i) => i !== index));
    } catch (error) {
      console.error('Error deleting driver:', error);
      alert('Failed to delete driver.');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };

  const filteredDrivers = drivers.filter(
    (driver) =>
      driver.clientId === clientId &&
      (driver.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        driver.lastName.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  return (
    <div className={styles.ultimatedriversSection}>
      <h3 className={styles.titleultimatedrivers}>Add or Edit Driver</h3>
      {licenseExpired && <p className={styles.expiredMessageultimatedrivers}>The driver's license has expired!</p>}
      <form className={styles.driverFormultimatedrivers}>
        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>First Name*</label>
            <input
              name="firstName"
              value={driverData.firstName}
              onChange={handleChange}
              placeholder="First Name"
              required
              className={styles.inputFieldultimatedrivers}
            />
          </div>
          <div className={styles.formGroupultimatedrivers}>
            <label>Last Name*</label>
            <input
              name="lastName"
              value={driverData.lastName}
              onChange={handleChange}
              placeholder="Last Name"
              required
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>Date Of Birth</label>
            <input
              name="dateOfBirth"
              type="date"
              value={driverData.dateOfBirth}
              onChange={handleChange}
              className={styles.inputFieldultimatedrivers}
            />
          </div>
          <div className={styles.formGroupultimatedrivers}>
            <label>Hire Date</label>
            <input
              name="hireDate"
              type="date"
              value={driverData.hireDate}
              onChange={handleChange}
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>Truck Number*</label>
            <select
              name="truckNumber"
              value={driverData.truckNumber}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatedrivers}
            >
              <option value="">Select Truck</option>
              {trucks.map((truck) => (
                <option key={truck._id} value={truck.truckNumber}>
                  {truck.truckNumber}
                </option>
              ))}
            </select>
          </div>
          <div className={styles.formGroupultimatedrivers}>
            <label>Email*</label>
            <input
              name="email"
              value={driverData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>Mobile Phone*</label>
            <input
              name="mobilePhone"
              value={driverData.mobilePhone}
              onChange={handleChange}
              placeholder="Mobile Phone"
              required
              className={styles.inputFieldultimatedrivers}
            />
          </div>
          <div className={styles.formGroupultimatedrivers}>
            <label>Phone*</label>
            <input
              name="phone"
              value={driverData.phone}
              onChange={handleChange}
              placeholder="Phone"
              required
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>Address*</label>
            <input
              name="address"
              value={driverData.address}
              onChange={handleChange}
              placeholder="Address"
              required
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>

        <h4>Emergency Contact</h4>
        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>First Name</label>
            <input
              name="emergencyContactFirstName"
              value={driverData.emergencyContactFirstName}
              onChange={handleChange}
              placeholder="First Name"
              className={styles.inputFieldultimatedrivers}
            />
          </div>
          <div className={styles.formGroupultimatedrivers}>
            <label>Last Name</label>
            <input
              name="emergencyContactLastName"
              value={driverData.emergencyContactLastName}
              onChange={handleChange}
              placeholder="Last Name"
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>
        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>Relation</label>
            <input
              name="emergencyContactRelation"
              value={driverData.emergencyContactRelation}
              onChange={handleChange}
              placeholder="Relation"
              className={styles.inputFieldultimatedrivers}
            />
          </div>
          <div className={styles.formGroupultimatedrivers}>
            <label>Phone</label>
            <input
              name="emergencyContactPhone"
              value={driverData.emergencyContactPhone}
              onChange={handleChange}
              placeholder="Phone"
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>

        <h4>Pay Settings</h4>
        <div className={styles.formGroupultimatedrivers}>
  <label>Settlement*</label>
  <select
    name="settlement"
    value={driverData.settlement}
    onChange={handleSettlementChange}
    required
    className={styles.selectFieldultimatedrivers}
  >
    <option value="">Select Payment Method</option>
    <option value="Hourly pay">Hourly pay</option>
    <option value="Per mile pay">Per mile pay</option>
    <option value="Fixed salary">Fixed salary</option>
    <option value="Percentage of the load">Percentage of the load</option>
    <option value="Team driver pay">Team driver pay</option>
  </select>
</div>
        {driverData.settlement === 'Per mile pay' && (
  <div className={styles.formRowultimatedrivers}>
    <div className={styles.formGroupultimatedrivers}>
      <label>Enter amount per normal mile ($)*</label>
      <input
        name="normalMileRate"
        type="number"
        step="0.01"
        value={driverData.normalMileRate || ''}
        onChange={handleChange}
        placeholder="Enter amount per normal mile"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
    <div className={styles.formGroupultimatedrivers}>
      <label>Enter amount per DH mile ($)*</label>
      <input
        name="dhMileRate"
        type="number"
        step="0.01"
        value={driverData.dhMileRate || ''}
        onChange={handleChange}
        placeholder="Enter amount per DH mile"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
  </div>
)}

{driverData.settlement === 'Hourly pay' && (
  <div className={styles.formRowultimatedrivers}>
    <div className={styles.formGroupultimatedrivers}>
      <label>Hourly Rate ($)*</label>
      <input
        name="hourlyRate"
        type="number"
        step="0.01"
        value={driverData.hourlyRate || ''}
        onChange={handleChange}
        placeholder="Enter hourly rate"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
    <div className={styles.formGroupultimatedrivers}>
      <label>Hours Worked*</label>
      <input
        name="hoursWorked"
        type="number"
        step="0.1"
        value={driverData.hoursWorked || ''}
        onChange={handleChange}
        placeholder="Enter hours worked"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
  </div>
)}

{driverData.settlement === 'Team driver pay' && (
  <div className={styles.formRowultimatedrivers}>
    <div className={styles.formGroupultimatedrivers}>
      <label>Select Co-Driver</label>
      <select
        name="teamDriver"
        value={driverData.teamDriver || ''}
        onChange={handleChange}
        required
        className={styles.selectFieldultimatedrivers}
      >
        <option value="">Select Co-Driver</option>
        {drivers.map((driver) => (
          <option key={driver._id} value={driver._id}>
            {driver.firstName} {driver.lastName}
          </option>
        ))}
      </select>
    </div>
    <div className={styles.formGroupultimatedrivers}>
      <label>Enter Team Pay Percentage (%)</label>
      <input
        name="teamPercentage"
        type="number"
        step="1"
        value={driverData.teamPercentage || ''}
        onChange={handleChange}
        placeholder="Enter team pay percentage"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
    <div className={styles.formGroupultimatedrivers}>
      <label>Enter Pay Amount for Main Driver ($)*</label>
      <input
        name="settlementAmount"
        type="number"
        step="0.01"
        value={driverData.settlementAmount || ''}
        onChange={handleChange}
        placeholder="Enter pay amount for main driver"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
  </div>
)}

{driverData.settlement === 'Percentage of the load' && (
  <div className={styles.formRowultimatedrivers}>
    <div className={styles.formGroupultimatedrivers}>
      <label>Enter Percentage of Load Revenue (%)</label>
      <input
        name="settlementAmount"
        type="number"
        step="1"
        value={driverData.settlementAmount || ''}
        onChange={handleChange}
        placeholder="Enter percentage of load (e.g., 20 for 20%)"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
  </div>
)}

{driverData.settlement === 'Fixed salary' && (
  <div className={styles.formRowultimatedrivers}>
    <div className={styles.formGroupultimatedrivers}>
      <label>Fixed Salary Amount ($)</label>
      <input
        name="settlementAmount"
        type="number"
        step="0.01"
        value={driverData.settlementAmount || ''}
        onChange={handleChange}
        placeholder="Enter fixed salary amount"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
  </div>
)}


        <h4>Licensing Info</h4>
        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>License Type</label>
            <select
              name="licenseType"
              value={driverData.licenseType}
              onChange={handleChange}
              className={styles.selectFieldultimatedrivers}
            >
              <option value="">Select License Type</option>
              <option value="CDL-A">CDL-A</option>
              <option value="CDL-B">CDL-B</option>
              <option value="NonCommercial">NonCommercial</option>
            </select>
          </div>
          <div className={styles.formGroupultimatedrivers}>
            <label>License State</label>
            <input
              name="licenseState"
              value={driverData.licenseState}
              onChange={handleChange}
              placeholder="Enter State"
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>License Number*</label>
          <input
            name="licenseNumber"
            value={driverData.licenseNumber}
            onChange={handleChange}
            placeholder="License Number"
            required
            className={styles.inputFieldultimatedrivers}
          />
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>License Expires*</label>
          <input
            name="licenseExpiryDate"
            type="date"
            value={driverData.licenseExpiryDate}
            onChange={handleChange}
            required
            className={styles.inputFieldultimatedrivers}
          />
        </div>

        <div className={styles.formGroupultimatedrivers}>
          <label>Passport Expires</label>
          <input
            name="passportExpiryDate"
            type="date"
            value={driverData.passportExpiryDate}
            onChange={handleChange}
            className={styles.inputFieldultimatedrivers}
          />
        </div>

        <h4>Medical Info</h4>
        <div className={styles.formGroupultimatedrivers}>
          <label>Last Medical</label>
          <input
            name="lastMedical"
            type="date"
            value={driverData.lastMedical}
            onChange={handleChange}
            className={styles.inputFieldultimatedrivers}
          />
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>Next Medical</label>
          <input
            name="nextMedical"
            type="date"
            value={driverData.nextMedical}
            onChange={handleChange}
            className={styles.inputFieldultimatedrivers}
          />
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>Last Drug Test</label>
          <input
            name="lastDrugTest"
            type="date"
            value={driverData.lastDrugTest}
            onChange={handleChange}
            className={styles.inputFieldultimatedrivers}
          />
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>Last Alcohol Test</label>
          <input
            name="lastAlcoholTest"
            type="date"
            value={driverData.lastAlcoholTest}
            onChange={handleChange}
            className={styles.inputFieldultimatedrivers}
          />
        </div>

        <h4>Corporate Info</h4>
        <div className={styles.formGroupultimatedrivers}>
          <label>Fuel Card Number</label>
          <input
            name="fuelCardNumber"
            value={driverData.fuelCardNumber}
            onChange={handleChange}
            placeholder="Fuel Card Number"
            className={styles.inputFieldultimatedrivers}
          />
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>Fuel Card Expires</label>
          <input
            name="fuelCardExpiryDate"
            type="date"
            value={driverData.fuelCardExpiryDate}
            onChange={handleChange}
            className={styles.inputFieldultimatedrivers}
          />
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>Fleet / Division</label>
          <input
            name="fleetDivision"
            value={driverData.fleetDivision}
            onChange={handleChange}
            placeholder="Fleet / Division"
            className={styles.inputFieldultimatedrivers}
          />
        </div>

        <h4>Employee Records Checklist</h4>
        <div className={styles.formGroupultimatedrivers}>
        <label>
  <input
    type="checkbox"
    checked={driverData.employeeRecordsChecklist?.copyOfLicense || false}
    onChange={(e) => handleCheckboxChange(e, 'employeeRecordsChecklist.copyOfLicense')}
  />
  Copy of License
</label>

          <label>
          <input
    type="checkbox"
    checked={driverData.employeeRecordsChecklist?.preEmploymentDrugTest || false}
    onChange={(e) => handleCheckboxChange(e, 'employeeRecordsChecklist.preEmploymentDrugTest')}
  />
            Pre-Employment Drug Test
          </label>
          <label>
  <input
    type="checkbox"
    checked={driverData.employeeRecordsChecklist?.longMedicalForm || false}
    onChange={(e) => handleCheckboxChange(e, 'employeeRecordsChecklist.longMedicalForm')}
  />
  Long Medical Form
</label>

          <label>
            <input
              type="checkbox"
              checked={driverData.employeeRecordsChecklist.copyOfRoadTest}
              onChange={(e) => handleCheckboxChange(e, 'employeeRecordsChecklist.copyOfRoadTest')}
            />
            Copy of Road Test
          </label>
          <label>
            <input
              type="checkbox"
              checked={driverData.employeeRecordsChecklist.enrolledInDrugTestingProgram}
              onChange={(e) => handleCheckboxChange(e, 'employeeRecordsChecklist.enrolledInDrugTestingProgram')}
            />
            Enrolled in Drug Testing Program
          </label>
          {/* Add more checklist items as needed */}
        </div>

        <h4>Internal Notes</h4>
        <div className={styles.formGroupultimatedrivers}>
          <textarea
            name="internalNotes"
            value={driverData.internalNotes}
            onChange={handleChange}
            placeholder="Internal Notes"
            className={styles.textareaFieldultimatedrivers}
          />
        </div>

        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimatedrivers}>
          {editingIndex !== null ? 'Update Driver' : 'Add Driver'}
        </button>
      </form>

      <h3 className={styles.titleultimatedrivers}>Search Drivers</h3>
      <input
        type="text"
        placeholder="Search by driver name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimatedrivers}
      />
     {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this driver?"
    onConfirm={() => confirmDeleteDriver(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}
     <h3 className={styles.titleultimatedrivers}>Existing Drivers</h3>
<ul className={styles.driverListultimatedrivers}>
  {filteredDrivers.map((driver, index) => (
    <li key={index} className={styles.driverListItemultimatedrivers}>
      {driver.firstName} {driver.lastName}
      <button onClick={() => handleEdit(index)} className={styles.editButtonultimatedrivers}>Edit</button>
      <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimatedrivers}
>
  Delete
</button>
     
    </li>
  ))}
</ul>

</div>
);
};


const Trucks = ({ trucks, setTrucks, drivers = [], trailers = [] }) => {
  const [limits, setLimits] = useState({ numberOfTrucks: 0 });
  const [truckData, setTruckData] = useState({
    truckNumber: '',
    licensePlate: '',
    VIN: '',
    truckType: '',
    fuelType: '',
    miles: '',
    inspectionDate: '',
    maintenanceDate: '',
    insurancePolicyNumber: '',
    insuranceExpiryDate: '',
    fleetDivision: '',
    driver: '',
    trailer: '',
    settlement: '',
    settlementAmount: '',
    normalMileRate: '',
    dhMileRate: '',
    hourlyRate: '',
    hoursWorked: '',
    teamDriver: '',
    teamPercentage: '',
    notes: '',
  });
  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);

  const token = sessionStorage.getItem('token'); // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId'); // Obține clientId din localStorage
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`, // Adaugă tokenul cu prefixul Bearer
      'Content-Type': 'application/json',
    },
    withCredentials: true, // Trimite cookies pentru autentificare
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTruckData({ ...truckData, [name]: value });
  };

  const handleSettlementChange = (e) => {
    const selectedSettlement = e.target.value;
    const resetData = {
      normalMileRate: selectedSettlement === 'Per mile pay' ? truckData.normalMileRate : undefined,
      dhMileRate: selectedSettlement === 'Per mile pay' ? truckData.dhMileRate : undefined,
      hourlyRate: selectedSettlement === 'Hourly pay' ? truckData.hourlyRate : undefined,
      hoursWorked: selectedSettlement === 'Hourly pay' ? truckData.hoursWorked : undefined,
      teamDriver: selectedSettlement === 'Team driver pay' ? truckData.teamDriver : undefined,
      teamPercentage: selectedSettlement === 'Team driver pay' ? truckData.teamPercentage : undefined,
      settlementAmount: selectedSettlement !== 'Per mile pay' && selectedSettlement !== 'Hourly pay' ? truckData.settlementAmount : undefined,
    };

    setTruckData({
      ...truckData,
      settlement: selectedSettlement,
      ...resetData,
    });
  };

  const handleSubmit = async () => {
    if (editingIndex === null && trucks.length >= limits.numberOfTrucks) {
      alert('Nu poți adăuga mai multe camioane decât limita stabilită.');
      return;
    }
    const validDriver = truckData.driver || null;
    const validTrailer = truckData.trailer || null;
    const dataToSend = {
        truckNumber: truckData.truckNumber, // Singurul câmp obligatoriu
        ...(truckData.licensePlate && { licensePlate: truckData.licensePlate }),
        ...(truckData.VIN && { VIN: truckData.VIN }),
        ...(truckData.truckType && { truckType: truckData.truckType }),
        ...(truckData.fuelType && { fuelType: truckData.fuelType }),
        ...(truckData.miles && { miles: truckData.miles }),
        ...(truckData.inspectionDate && { inspectionDate: truckData.inspectionDate }),
        ...(truckData.maintenanceDate && { maintenanceDate: truckData.maintenanceDate }),
        ...(truckData.insurancePolicyNumber && { insurancePolicyNumber: truckData.insurancePolicyNumber }),
        ...(truckData.insuranceExpiryDate && { insuranceExpiryDate: truckData.insuranceExpiryDate }),
        ...(truckData.fleetDivision && { fleetDivision: truckData.fleetDivision }),
        ...(validDriver && { driver: validDriver }),
        ...(validTrailer && { trailer: validTrailer }),
        ...(truckData.notes && { notes: truckData.notes }),
        ...(truckData.settlement && { settlement: truckData.settlement }),
        ...(truckData.settlementAmount && { settlementAmount: truckData.settlementAmount }),
        ...(truckData.normalMileRate && { normalMileRate: truckData.normalMileRate }),
        ...(truckData.dhMileRate && { dhMileRate: truckData.dhMileRate }),
        ...(truckData.hourlyRate && { hourlyRate: truckData.hourlyRate }),
        ...(truckData.hoursWorked && { hoursWorked: truckData.hoursWorked }),
        ...(truckData.teamDriver && { teamDriver: truckData.teamDriver }),
        ...(truckData.teamPercentage && { teamPercentage: truckData.teamPercentage }),
        clientId,
      };
      
    

    if (editingIndex !== null) {
      try {
        const response = await axios.put(`${apiUrl}/trucks/${trucks[editingIndex]._id}`, dataToSend, config);
        const updatedTrucks = [...trucks];
        updatedTrucks[editingIndex] = response.data.truck;
        setTrucks(updatedTrucks);
        setEditingIndex(null);
      } catch (error) {
        console.error('Error updating truck:', error);
      }
    } else {
      try {
        const response = await axios.post(`${apiUrl}/trucks`, dataToSend, config);
        setTrucks([...trucks, response.data.truck]);
      } catch (error) {
        console.error('Error adding truck:', error);
      }
    }

    setTruckData({
      truckNumber: '',
      licensePlate: '',
      VIN: '',
      truckType: '',
      fuelType: '',
      miles: '',
      inspectionDate: '',
      maintenanceDate: '',
      insurancePolicyNumber: '',
      insuranceExpiryDate: '',
      fleetDivision: '',
      driver: '',
      trailer: '',
      settlement: '',
      settlementAmount: '',
      normalMileRate: '',
      dhMileRate: '',
      hourlyRate: '',
      hoursWorked: '',
      teamDriver: '',
      teamPercentage: '',
      notes: '',
    });
  };

  useEffect(() => {
    const fetchTruckLimit = async () => {
      try {
        const response = await axios.get(`${apiUrl}/clients`, config);
        setLimits({
          numberOfTrucks: response.data.numberOfTrucks,
        });
      } catch (error) {
        console.error('Error fetching truck limit:', error);
      }
    };
    
    fetchTruckLimit();
  }, []);

  const handleEdit = (index) => {
    const truckToEdit = trucks[index];
    setEditingIndex(index);
    setTruckData({
      truckNumber: truckToEdit.truckNumber || '',
      licensePlate: truckToEdit.licensePlate || '',
      VIN: truckToEdit.VIN || '',
      truckType: truckToEdit.truckType || '',
      fuelType: truckToEdit.fuelType || '',
      miles: truckToEdit.miles || '',
      inspectionDate: truckToEdit.inspectionDate || '',
      maintenanceDate: truckToEdit.maintenanceDate || '',
      insurancePolicyNumber: truckToEdit.insurancePolicyNumber || '',
      insuranceExpiryDate: truckToEdit.insuranceExpiryDate || '',
      fleetDivision: truckToEdit.fleetDivision || '',
      driver: truckToEdit.driver || '',
      trailer: truckToEdit.trailer || '',
      settlement: truckToEdit.settlement || '',
      settlementAmount: truckToEdit.settlementAmount || '',
      normalMileRate: truckToEdit.normalMileRate || '',
      dhMileRate: truckToEdit.dhMileRate || '',
      notes: truckToEdit.notes || '',
      
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  

  const confirmDeleteTruck = async (index) => {
    try {
      const truckId = trucks[index]._id;
      await axios.delete(`${apiUrl}/trucks/${truckId}`, config);
      setTrucks((prevTrucks) => prevTrucks.filter((_, i) => i !== index));
    } catch (error) {
      console.error('Error deleting truck:', error);
      alert('Failed to delete truck.');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  

  const filteredTrucks = trucks.filter(truck =>
    truck.truckNumber && truck.truckNumber.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className={styles.ultimatetrucksSection}>
      <h3 className={styles.titleultimatetrucks}>Add or Edit Truck</h3>
      <form className={styles.truckFormultimatetrucks}>
        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Truck Number*</label>
            <input
              name="truckNumber"
              value={truckData.truckNumber}
              onChange={handleChange}
              placeholder="Truck Number"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>License Plate*</label>
            <input
              name="licensePlate"
              value={truckData.licensePlate}
              onChange={handleChange}
              placeholder="License Plate"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
        </div>

        <h4>Pay Settings</h4>
        <div className={styles.formGroupultimatetrucks}>
          <label>Settlement*</label>
          <select
            name="settlement"
            value={truckData.settlement}
            onChange={handleSettlementChange}
            required
            className={styles.selectFieldultimatetrucks}
          >
            <option value="">Select Payment Method</option>
            <option value="Hourly pay">Hourly pay</option>
            <option value="Per mile pay">Per mile pay</option>
            <option value="Fixed salary">Fixed salary</option>
            <option value="Percentage of the load">Percentage of the load</option>
            <option value="Team driver pay">Team driver pay</option>
          </select>
        </div>

        {truckData.settlement === 'Per mile pay' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Enter amount per normal mile ($)*</label>
              <input
                name="normalMileRate"
                type="number"
                step="0.01"
                value={truckData.normalMileRate || ''}
                onChange={handleChange}
                required
                className={styles.inputFieldultimatetrucks}
              />
            </div>
            <div className={styles.formGroupultimatetrucks}>
              <label>Enter amount per DH mile ($)*</label>
              <input
                name="dhMileRate"
                type="number"
                step="0.01"
                value={truckData.dhMileRate || ''}
                onChange={handleChange}
                required
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        {truckData.settlement === 'Hourly pay' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Hourly Rate ($)*</label>
              <input
                name="hourlyRate"
                type="number"
                step="0.01"
                value={truckData.hourlyRate || ''}
                onChange={handleChange}
                required
                className={styles.inputFieldultimatetrucks}
              />
            </div>
            <div className={styles.formGroupultimatetrucks}>
              <label>Hours Worked*</label>
              <input
                name="hoursWorked"
                type="number"
                step="0.1"
                value={truckData.hoursWorked || ''}
                onChange={handleChange}
                required
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        {truckData.settlement === 'Team driver pay' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Select Co-Driver</label>
              <input
                name="teamDriver"
                value={truckData.teamDriver || ''}
                onChange={handleChange}
                className={styles.inputFieldultimatetrucks}
              />
            </div>
            <div className={styles.formGroupultimatetrucks}>
              <label>Enter Team Pay Percentage (%)</label>
              <input
                name="teamPercentage"
                type="number"
                step="1"
                value={truckData.teamPercentage || ''}
                onChange={handleChange}
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        {truckData.settlement === 'Percentage of the load' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Enter Percentage of Load Revenue (%)</label>
              <input
                name="settlementAmount"
                type="number"
                step="1"
                value={truckData.settlementAmount || ''}
                onChange={handleChange}
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        {truckData.settlement === 'Fixed salary' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Fixed Salary Amount ($)</label>
              <input
                name="settlementAmount"
                type="number"
                step="0.01"
                value={truckData.settlementAmount || ''}
                onChange={handleChange}
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>VIN*</label>
            <input
              name="VIN"
              value={truckData.VIN}
              onChange={handleChange}
              placeholder="VIN"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>Truck Type*</label>
            <select
              name="truckType"
              value={truckData.truckType}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrucks}
            >
              <option value="">Select Type</option>
              <option value="Semi-truck">Semi-truck</option>
              <option value="Trailer">Trailer</option>
            </select>
          </div>
        </div>

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Fuel Type*</label>
            <select
              name="fuelType"
              value={truckData.fuelType}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrucks}
            >
              <option value="">Select Fuel Type</option>
              <option value="Diesel">Diesel</option>
              <option value="Gasoline">Gasoline</option>
            </select>
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>Miles*</label>
            <input
              name="miles"
              value={truckData.miles}
              onChange={handleChange}
              placeholder="Miles"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Driver*</label>
            <select
              name="driver"
              value={truckData.driver}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrucks}
            >
              <option value="">Select Driver</option>
              {Array.isArray(drivers) && drivers.map((driver) => (
                <option key={driver._id} value={driver._id}>
                  {driver.firstName} {driver.lastName}
                </option>
              ))}
            </select>
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>Trailer*</label>
            <select
              name="trailer"
              value={truckData.trailer}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrucks}
            >
              <option value="">Select Trailer</option>
              {Array.isArray(trailers) && trailers.map((trailer) => (
                <option key={trailer._id} value={trailer._id}>
                  {trailer.trailerNumber}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Inspection Date*</label>
            <input
              name="inspectionDate"
              type="date"
              value={truckData.inspectionDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>Maintenance Date*</label>
            <input
              name="maintenanceDate"
              type="date"
              value={truckData.maintenanceDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Insurance Policy Number*</label>
            <input
              name="insurancePolicyNumber"
              value={truckData.insurancePolicyNumber}
              onChange={handleChange}
              placeholder="Insurance Policy Number"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>Insurance Expiry Date*</label>
            <input
              name="insuranceExpiryDate"
              type="date"
              value={truckData.insuranceExpiryDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
        </div>

        <div className={styles.formGroupultimatetrucks}>
          <label>Fleet Division*</label>
          <input
            name="fleetDivision"
            value={truckData.fleetDivision}
            onChange={handleChange}
            placeholder="Fleet Division"
            required
            className={styles.inputFieldultimatetrucks}
          />
        </div>
        
        <div className={styles.formGroupultimatetrucks}>
          <label>Notes</label>
          <textarea
            name="notes"
            value={truckData.notes}
            onChange={handleChange}
            placeholder="Notes"
            className={styles.textareaFieldultimatetrucks}
          ></textarea>
        </div>

        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimatetrucks}>
          {editingIndex !== null ? 'Update Truck' : 'Add Truck'}
        </button>
      </form>

      <h3 className={styles.titleultimatetrucks}>Search Trucks</h3>
      <input
        type="text"
        placeholder="Search by truck number"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimatetrucks}
      />
           {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this truck?"
    onConfirm={() => confirmDeleteTruck(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}

      <h3 className={styles.titleultimatetrucks}>Existing Trucks</h3>
      <ul className={styles.truckListultimatetrucks}>
        {filteredTrucks.map((truck, index) => (
          <li key={index} className={styles.truckListItemultimatetrucks}>
            {truck.truckNumber}
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimatetrucks}>
              Edit
            </button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimatetrucks}
>
  Delete
</button>

          </li>
        ))}
      </ul>
    </div>
  );
};


const Trailers = ({ trailers = [], setTrailers }) => {
  const [trailerData, setTrailerData] = useState({
    trailerNumber: '',
    licensePlate: '',
    VIN: '',
    trailerType: '',
    capacity: '',
    length: '',
    inspectionDate: '',
    maintenanceDate: '',
    insurancePolicyNumber: '',
    insuranceExpiryDate: '',
    fleetDivision: '',
    notes: ''
  });

  const apiUrl = 'https://api-backend.full-trucking-service.com/api'; 
  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [alarms, setAlarms] = useState({ inspectionAlarm: false, maintenanceAlarm: false, insuranceAlarm: false });
  const [deleteTarget, setDeleteTarget] = useState(null);


  const token = sessionStorage.getItem('token'); 
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    withCredentials: true,
  };

  // Fetch trailers
  const fetchTrailers = async () => {
    try {
      const response = await axios.get(`${apiUrl}/trailers`, config);
      setTrailers(response.data);
    } catch (error) {
      console.error('Error fetching trailers:', error);
    }
  };

  useEffect(() => {
    fetchTrailers();
  }, []);

  // Function to check if any date has expired or reached the current date
  const checkAlarms = () => {
    const today = new Date().toISOString().split('T')[0];
    setAlarms({
      inspectionAlarm: trailerData.inspectionDate && trailerData.inspectionDate <= today,
      maintenanceAlarm: trailerData.maintenanceDate && trailerData.maintenanceDate <= today,
      insuranceAlarm: trailerData.insuranceExpiryDate && trailerData.insuranceExpiryDate <= today,
    });
  };

  useEffect(() => {
    checkAlarms();
  }, [trailerData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTrailerData({ ...trailerData, [name]: value });
  };

  const handleSubmit = async () => {
    if (editingIndex !== null) {
      const updatedTrailers = [...trailers];
      updatedTrailers[editingIndex] = { ...trailerData };
      setTrailers(updatedTrailers);
      setEditingIndex(null);
    } else {
      try {
        const response = await axios.post(`${apiUrl}/trailers`, trailerData, config);
        if (response.status === 201) {
          setTrailers([...trailers, response.data]);
        }
      } catch (error) {
        console.error('Error adding trailer:', error);
      }
    }

    setTrailerData({
      trailerNumber: '',
      licensePlate: '',
      VIN: '',
      trailerType: '',
      capacity: '',
      length: '',
      inspectionDate: '',
      maintenanceDate: '',
      insurancePolicyNumber: '',
      insuranceExpiryDate: '',
      fleetDivision: '',
      notes: ''
    });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setTrailerData(trailers[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteTrailer = async (index) => {
    try {
      const trailerId = trailers[index]._id;
      await axios.delete(`${apiUrl}/trailers/${trailerId}`, config);
      setTrailers((prevTrailers) => prevTrailers.filter((_, i) => i !== index));
    } catch (error) {
      console.error('Error deleting trailer:', error);
      alert('Failed to delete trailer.');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  

  const filteredTrailers = trailers.filter(
    (trailer) => 
      trailer?.trailerNumber?.toLowerCase().includes(searchQuery.toLowerCase()) || 
      trailer?.VIN?.toLowerCase().includes(searchQuery.toLowerCase())
  );
  

  return (
    <div className={styles.ultimatetrailersSection}>
      <h3 className={styles.titleultimatetrailers}>Add or Edit Trailer</h3>
      {alarms.inspectionAlarm && <p className={styles.alarmMessageultimatetrailers}>Inspection date has expired!</p>}
      {alarms.maintenanceAlarm && <p className={styles.alarmMessageultimatetrailers}>Maintenance date has expired!</p>}
      {alarms.insuranceAlarm && <p className={styles.alarmMessageultimatetrailers}>Insurance has expired!</p>}

      <form className={styles.trailerFormultimatetrailers}>
        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>Trailer Number*</label>
            <input
              name="trailerNumber"
              value={trailerData.trailerNumber}
              onChange={handleChange}
              placeholder="Trailer Number"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>License Plate*</label>
            <input
              name="licensePlate"
              value={trailerData.licensePlate}
              onChange={handleChange}
              placeholder="License Plate"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>VIN*</label>
            <input
              name="VIN"
              value={trailerData.VIN}
              onChange={handleChange}
              placeholder="VIN"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>Trailer Type*</label>
            <select
              name="trailerType"
              value={trailerData.trailerType}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrailers}
            >
              <option value="">Select Type</option>
              <option value="Platform">Platform</option>
              <option value="Refrigerated">Refrigerated</option>
              <option value="Container">Container</option>
            </select>
          </div>
        </div>

        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>Capacity*</label>
            <input
              name="capacity"
              value={trailerData.capacity}
              onChange={handleChange}
              placeholder="Capacity"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>Length*</label>
            <input
              name="length"
              value={trailerData.length}
              onChange={handleChange}
              placeholder="Length"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>Inspection Date*</label>
            <input
              name="inspectionDate"
              type="date"
              value={trailerData.inspectionDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>Maintenance Date*</label>
            <input
              name="maintenanceDate"
              type="date"
              value={trailerData.maintenanceDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>Insurance Policy Number*</label>
            <input
              name="insurancePolicyNumber"
              value={trailerData.insurancePolicyNumber}
              onChange={handleChange}
              placeholder="Insurance Policy Number"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>Insurance Expiry Date*</label>
            <input
              name="insuranceExpiryDate"
              type="date"
              value={trailerData.insuranceExpiryDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
        </div>

        <div className={styles.formGroupultimatetrailers}>
          <label>Fleet Division*</label>
          <input
            name="fleetDivision"
            value={trailerData.fleetDivision}
            onChange={handleChange}
            placeholder="Fleet Division"
            required
            className={styles.inputFieldultimatetrailers}
          />
        </div>

        <div className={styles.formGroupultimatetrailers}>
          <label>Notes</label>
          <textarea
            name="notes"
            value={trailerData.notes}
            onChange={handleChange}
            placeholder="Notes"
            className={styles.textareaFieldultimatetrailers}
          ></textarea>
        </div>

        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimatetrailers}>
          {editingIndex !== null ? 'Update Trailer' : 'Add Trailer'}
        </button>
      </form>

      <h3 className={styles.titleultimatetrailers}>Search Trailers</h3>
      <input
        type="text"
        placeholder="Search by trailer number or VIN"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimatetrailers}
      />
  {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this trailer?"
    onConfirm={() => confirmDeleteTrailer(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}
      <h3 className={styles.titleultimatetrailers}>Existing Trailers</h3>
      <ul className={styles.trailerListultimatetrailers}>
        {filteredTrailers.map((trailer, index) => (
          <li key={index} className={styles.trailerListItemultimatetrailers}>
            {trailer.trailerNumber} ({trailer.VIN})
    
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimatetrailers}>Edit</button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimatetrailers}
>
  Delete
</button>

          </li>
        ))}
      </ul>
    </div>
  );
};



// Componenta Brokers
const Brokers = ({ brokers, setBrokers }) => {
  const [brokerData, setBrokerData] = useState({
    brokerName: '',
    brokerAddress: '',
    email: '',
    phone: '',
  });

  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);


  const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,  // Adaugă tokenul cu prefixul Bearer
        // Adaugă Content-Type
    },
    withCredentials: true,  // Trimite cookies pentru autentificare
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setBrokerData({ ...brokerData, [name]: value });
  };

  const handleSubmit = async () => {
    
    const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
    const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json',
      },
      withCredentials: true,  // Trimite și cookies pentru autentificare
    };
    if (editingIndex !== null) {
      // Update existing broker
      const updatedBrokers = [...brokers];
      updatedBrokers[editingIndex] = brokerData;
      setBrokers(updatedBrokers);
      setEditingIndex(null);
    } else {
      // Add new broker
      try {
        const dataToSend = { ...brokerData, clientId };
        const response = await axios.post(`${apiUrl}/brokers`, dataToSend, config);
        setBrokers([...brokers, response.data]);
      } catch (error) {
        console.error('Error adding broker:', error);
      }
    }
    setBrokerData({
      brokerName: '',
      brokerAddress: '',
      email: '',
      phone: '',
    });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setBrokerData(brokers[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteBroker = async (index) => {
    try {
      const brokerId = brokers[index]._id;
      await axios.delete(`${apiUrl}/brokers/${brokerId}`, config);
      setBrokers((prevBrokers) => prevBrokers.filter((_, i) => i !== index));
    } catch (error) {
      console.error('Error deleting broker:', error);
      alert('Failed to delete broker.');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  

  const filteredBrokers = brokers.filter(broker =>
    broker.brokerName && broker.brokerName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  

  return (
    <div className={styles.ultimatebrokersSection}>
      <h3 className={styles.titleultimatebrokers}>Add or Edit Broker</h3>
      <form className={styles.brokerFormultimatebrokers}>
        <div className={styles.formRowultimatebrokers}>
          <div className={styles.formGroupultimatebrokers}>
            <label>Broker Name*</label>
            <input
              name="brokerName"
              value={brokerData.brokerName}
              onChange={handleChange}
              placeholder="Broker Name"
              required
              className={styles.inputFieldultimatebrokers}
            />
          </div>
          <div className={styles.formGroupultimatebrokers}>
            <label>Address*</label>
            <input
              name="address"
              value={brokerData.brokerAddress}
              onChange={handleChange}
              placeholder="Address"
              required
              className={styles.inputFieldultimatebrokers}
            />
          </div>
        </div>
  
        <div className={styles.formRowultimatebrokers}>
          <div className={styles.formGroupultimatebrokers}>
            <label>Email*</label>
            <input
              name="email"
              value={brokerData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className={styles.inputFieldultimatebrokers}
            />
          </div>
          <div className={styles.formGroupultimatebrokers}>
            <label>Phone*</label>
            <input
              name="phone"
              value={brokerData.phone}
              onChange={handleChange}
              placeholder="Phone"
              required
              className={styles.inputFieldultimatebrokers}
            />
          </div>
        </div>
  
        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimatebrokers}>
          {editingIndex !== null ? 'Update Broker' : 'Add Broker'}
        </button>
      </form>
  
      <h3 className={styles.titleultimatebrokers}>Search Brokers</h3>
      <input
        type="text"
        placeholder="Search by broker name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimatebrokers}
      />
              {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this broker?"
    onConfirm={() => confirmDeleteBroker(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}
      <h3 className={styles.titleultimatebrokers}>Existing Brokers</h3>
      <ul className={styles.brokerListultimatebrokers}>
        {filteredBrokers.map((broker, index) => (
          <li key={index} className={styles.brokerListItemultimatebrokers}>
            {broker.brokerName}
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimatebrokers}>
              Edit
            </button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimatebrokers}
>
  Delete
</button>
          </li>
        ))}
      </ul>
    </div>
  );
  
};



// Componenta Shippers
const Shippers = ({ shippers, setShippers }) => {
  const [shipperData, setShipperData] = useState({
    shipperName: '',
    shipperAddress: '',
    email: '',
    phone: '',
  });

  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);


  const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,  // Adaugă tokenul cu prefixul Bearer
        // Adaugă Content-Type
    },
    withCredentials: true,  // Trimite cookies pentru autentificare
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setShipperData({ ...shipperData, [name]: value });
  };

  const handleSubmit = async () => { 
    const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
    const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json',
      },
      withCredentials: true,  // Trimite și cookies pentru autentificare
    };
    if (editingIndex !== null) {
      // Update existing shipper
      const updatedShippers = [...shippers];
      updatedShippers[editingIndex] = shipperData;
      setShippers(updatedShippers);
      setEditingIndex(null);
    } else {
      // Add new shipper
      try {
        const dataToSend = { ...shipperData, clientId };  // Adaugă clientId la datele de trimis
        const response = await axios.post(`${apiUrl}/shippers`, shipperData,config);
        setShippers([...shippers, response.data]);
      } catch (error) {
        console.error('Error adding shipper:', error);
      }
    }
    setShipperData({
      shipperName: '',
      shipperAddress: '',
      email: '',
      phone: '',
    });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setShipperData(shippers[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteShipper = async (index) => {
    try {
      const shipperId = shippers[index]._id;
      await axios.delete(`${apiUrl}/shippers/${shipperId}`, config);
      setShippers((prevShippers) => prevShippers.filter((_, i) => i !== index));
    } catch (error) {
      console.error('Error deleting shipper:', error);
      alert('Failed to delete shipper.');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  
  
  const filteredShippers = shippers.filter(shipper =>
    shipper.shipperName && shipper.shipperName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  
  
  return (
    <div className={styles.ultimateshippersSection}>
      <h3 className={styles.titleultimateshippers}>Add or Edit Shipper</h3>
      <form className={styles.shipperFormultimateshippers}>
        <div className={styles.formRowultimateshippers}>
          <div className={styles.formGroupultimateshippers}>
            <label>Shipper Name*</label>
            <input
              name="shipperName"
              value={shipperData.shipperName}
              onChange={handleChange}
              placeholder="Shipper Name"
              required
              className={styles.inputFieldultimateshippers}
            />
          </div>
          <div className={styles.formGroupultimateshippers}>
            <label>Address*</label>
            <input
              name="shipperAddress"
              value={shipperData.shipperAddressultimateshippers}
              onChange={handleChange}
              placeholder="Address"
              required
              className={styles.inputFieldultimateshippers}
            />
          </div>
        </div>
  
        <div className={styles.formRowultimateshippers}>
          <div className={styles.formGroupultimateshippers}>
            <label>Email*</label>
            <input
              name="email"
              value={shipperData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className={styles.inputFieldultimateshippers}
            />
          </div>
          <div className={styles.formGroupultimateshippers}>
            <label>Phone*</label>
            <input
              name="phone"
              value={shipperData.phone}
              onChange={handleChange}
              placeholder="Phone"
              required
              className={styles.inputFieldultimateshippers}
            />
          </div>
        </div>
  
        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimateshippers}>
          {editingIndex !== null ? 'Update Shipper' : 'Add Shipper'}
        </button>
      </form>
  
      <h3 className={styles.titleultimateshippers}>Search Shippers</h3>
      <input
        type="text"
        placeholder="Search by shipper name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimateshippers}
      />
           {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this shipper?"
    onConfirm={() => confirmDeleteShipper(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}
      <h3 className={styles.titleultimateshippers}>Existing Shippers</h3>
      <ul className={styles.shipperListultimateshippers}>
        {filteredShippers.map((shipper, index) => (
          <li key={index} className={styles.shipperListItemultimateshippers}>
            {shipper.shipperName}
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimateshippers}>
              Edit
            </button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimateshippers}
>
  Delete
</button>

          </li>
        ))}
      </ul>
    </div>
  );
}  

// Componenta Consignees
const Consignees = ({ consignees, setConsignees }) => {
  const [consigneeData, setConsigneeData] = useState({
    consigneeName: '',
    consigneeAddress: '',
    email: '',
    phone: '',
    notes: '',
  });

  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);

  
  const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,  // Adaugă tokenul cu prefixul Bearer
        // Adaugă Content-Type
    },
    withCredentials: true,  // Trimite cookies pentru autentificare
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setConsigneeData({ ...consigneeData, [name]: value });
  };

  const handleSubmit = async () => {
    const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
    const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json',
      },
      withCredentials: true,  // Trimite și cookies pentru autentificare
    };
    if (editingIndex !== null) {
      // Update existing consignee
      const updatedConsignees = [...consignees];
      updatedConsignees[editingIndex] = consigneeData;
      setConsignees(updatedConsignees);
      setEditingIndex(null);
    } else {
      // Add new consignee
      try {
        const dataToSend = { ...consigneeData, clientId };
        const response = await axios.post(`${apiUrl}/consignees`, consigneeData, config);
       setConsignees([...consignees, response.data]);
      } catch (error) {
        console.error('Error adding consignee:', error);
      }
    }
    setConsigneeData({
      consigneeName: '',
      consigneeAddress: '',
      email: '',
      phone: '',
    });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setConsigneeData(consignees[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteConsignee = async (index) => {
    try {
      const consigneeId = consignees[index]._id;
      await axios.delete(`${apiUrl}/consignees/${consigneeId}`, config);
      setConsignees((prevConsignees) => prevConsignees.filter((_, i) => i !== index));
    } catch (error) {
      console.error('Error deleting consignee:', error);
      alert('Failed to delete consignee.');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  

  const filteredConsignees = consignees.filter(consignee =>
    consignee.consigneeName && consignee.consigneeName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  
  return (
    <div className={styles.ultimateconsigneesSection}>
      <h3 className={styles.titleultimateconsignees}>Add or Edit Consignee</h3>
      <form className={styles.consigneeFormultimateconsignees}>
        <div className={styles.formRowultimateconsignees}>
          <div className={styles.formGroupultimateconsignees}>
            <label>Consignee Name*</label>
            <input
              name="consigneeName"
              value={consigneeData.consigneeName}
              onChange={handleChange}
              placeholder="Consignee Name"
              required
              className={styles.inputFieldultimateconsignees}
            />
          </div>
          <div className={styles.formGroupultimateconsignees}>
            <label>Address*</label>
            <input
              name="consigneeAddress"
              value={consigneeData.consigneeAddressultimateconsignees}
              onChange={handleChange}
              placeholder="Address"
              required
              className={styles.inputFieldultimateconsignees}
            />
          </div>
        </div>
  
        <div className={styles.formRowultimateconsignees}>
          <div className={styles.formGroupultimateconsignees}>
            <label>Email*</label>
            <input
              name="email"
              value={consigneeData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className={styles.inputFieldultimateconsignees}
            />
          </div>
          <div className={styles.formGroupultimateconsignees}>
            <label>Phone*</label>
            <input
              name="phone"
              value={consigneeData.phone}
              onChange={handleChange}
              placeholder="Phone"
              required
              className={styles.inputFieldultimateconsignees}
            />
          </div>
        </div>
  
        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimateconsignees}>
          {editingIndex !== null ? 'Update Consignee' : 'Add Consignee'}
        </button>
      </form>
  
      <h3 className={styles.titleultimateconsignees}>Search Consignees</h3>
      <input
        type="text"
        placeholder="Search by consignee name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimateconsignees}
      />
              {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this consignee?"
    onConfirm={() => confirmDeleteConsignee(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}

      <h3 className={styles.titleultimateconsignees}>Existing Consignees</h3>
      <ul className={styles.consigneeListultimateconsignees}>
        {filteredConsignees.map((consignee, index) => (
          <li key={index} className={styles.consigneeListItemultimateconsignees}>
            {consignee.consigneeName}
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimateconsignees}>
              Edit
            </button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimateconsignees}
>
  Delete
</button>

          </li>
        ))}
      </ul>
    </div>
  );
  
};
const statusOrder = [
  "Open",
  "Pending",
  "Dispatched",
  "Assigned",
  "In Progress",
  "On Route",
  "Delivered",
  "Completed",
];

const LoadFinder = ({ loads }) => {
  const [search, setSearch] = useState("");
  const [drivers, setDrivers] = useState([]);
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedLoad, setSelectedLoad] = useState(null);
  const apiUrl = "https://api-backend.full-trucking-service.com/api";
  const token = sessionStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };

  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const response = await axios.get(`${apiUrl}/drivers`, config);
        setDrivers(response.data);
      } catch (error) {
        console.error("Error fetching drivers:", error);
      }
    };

    fetchDrivers();
  }, []);

  useEffect(() => {
    const activeLoads = loads
      .filter((load) => !["Completed", "Cancelled"].includes(load.status))
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    setFilteredLoads(activeLoads);
  }, [loads]);

  // ✅ Corectat funcția pentru a găsi numele șoferului corect
  const getDriverName = (driverId) => {
    if (!driverId) return "No Driver";

    const driver = drivers.find((d) => d._id === driverId);
    return driver ? `${driver.firstName} ${driver.lastName}` : "Unknown Driver";
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    const query = e.target.value.toLowerCase();

    const filtered = loads
      .filter(
        (load) =>
          !["Completed", "Cancelled"].includes(load.status) &&
          (load.loadNumber.toLowerCase().includes(query) ||
            (load.driver && getDriverName(load.driver).toLowerCase().includes(query)) ||
            (load.clientId && load.clientId.toLowerCase().includes(query)))
      )
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    setFilteredLoads(filtered);
  };

  const getNextStatus = (currentStatus) => {
    const index = statusOrder.indexOf(currentStatus);
    return index !== -1 && index < statusOrder.length - 1 ? statusOrder[index + 1] : "Completed";
  };

  const handleNextStatus = async () => {
    if (!selectedLoad) return;

    const nextStatus = getNextStatus(selectedLoad.status);

    try {
      const response = await axios.put(
        `${apiUrl}/loads/${selectedLoad._id}`,
        { status: nextStatus },
        config
      );

      if (response.status === 200) {
        setFilteredLoads((prevLoads) =>
          prevLoads
            .map((load) =>
              load._id === selectedLoad._id ? { ...load, status: nextStatus } : load
            )
            .filter((load) => load.status !== "Completed")
        );
        setSelectedLoad((prev) => (prev ? { ...prev, status: nextStatus } : null));
      }
    } catch (error) {
      console.error("Error updating load status:", error);
    }
  };

  return (
    <div className={styles.loadFinderSection}>
      <h2>Load Tracker</h2>
      <input
        type="text"
        placeholder="Search by Load #, Driver, Client ID"
        value={search}
        onChange={handleSearch}
        className={styles.searchInputloadFinder}
      />

      <ul className={styles.loadListloadFinder}>
        {filteredLoads.map((load) => (
          <li
            key={load._id}
            className={styles.loadItemloadFinder}
            onClick={() => setSelectedLoad(load)}
          >
            <strong>Load #:</strong> {load.loadNumber} <br />
            <strong>Dispatcher:</strong> {load.dispatcher} <br />
            <strong>Driver:</strong> {getDriverName(load.driver)} <br />
            <strong>Status:</strong> {load.status} <br />
          </li>
        ))}
      </ul>

      {/* 🔥 Modal pentru schimbarea statusului, afișat pe mijlocul ecranului */}
      {selectedLoad && (
        <>
          <div className={styles.modalBackdrop} onClick={() => setSelectedLoad(null)}></div>
          <div className={styles.modalContainer}>
            <h3>Load Details</h3>
            <p>
              <strong>Dispatcher:</strong> {selectedLoad.dispatcher}
            </p>
            <p>
              <strong>Load #:</strong> {selectedLoad.loadNumber}
            </p>
            <p>
              <strong>Driver:</strong> {getDriverName(selectedLoad.driver)}
            </p>
            <p>
              <strong>Status:</strong> {selectedLoad.status}
            </p>
            <p>
              <strong>Payment Status:</strong> {selectedLoad.paymentStatus}
            </p>
            <button className={styles.nextButtonloadFind} onClick={handleNextStatus}>
              Next Status: {getNextStatus(selectedLoad.status)}
            </button>
            <button className={styles.closeButtonloadFinder} onClick={() => setSelectedLoad(null)}>
              Close
            </button>
          </div>
        </>
      )}
    </div>
  );
};


const LoadManager = ({ loads, setLoads,selectedLoadId }) => {
  const [editingLoad, setEditingLoad] = useState(null);
  const [search, setSearch] = useState('');
  const [drivers, setDrivers] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState('');
  const [selectedTruck, setSelectedTruck] = useState("");
  const [deleteTarget, setDeleteTarget] = useState(null);
  const editSectionRef = useRef(null);


  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const token = sessionStorage.getItem('token');
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    },
    withCredentials: true
  };
  useEffect(() => {
    if (selectedLoadId) {
      const selectedLoad = loads.find((load) => load._id === selectedLoadId);
      if (selectedLoad) {
        setEditingLoad(selectedLoad); // Setăm `editingLoad` pentru a deschide editorul
      }
    }
  }, [selectedLoadId, loads]);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const driversRes = await axios.get(`${apiUrl}/drivers`, config);
        setDrivers(driversRes.data);

        const trucksRes = await axios.get(`${apiUrl}/trucks`, config);
        setTrucks(trucksRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const filtered = loads.filter((load) => {
      const searchTerm = search.toLowerCase();

      const matchesSearch =
        (load.loadNumber && load.loadNumber.toLowerCase().includes(searchTerm)) ||
        (load.brokerName && load.brokerName.toLowerCase().includes(searchTerm)) ||
        (load.brokerAddress && load.brokerAddress.toLowerCase().includes(searchTerm)) ||
        (load.rate && load.rate.toString().includes(searchTerm)) ||
        (load.miles && load.miles.toString().includes(searchTerm)) ||
        (load.dh && load.dh.toString().includes(searchTerm)) ||
        (load.notes && load.notes.toLowerCase().includes(searchTerm)) ||
        (load.status && load.status.toLowerCase().includes(searchTerm)) ||
        load.shippers.some((shipper) =>
          (shipper.name && shipper.name.toLowerCase().includes(searchTerm)) ||
          (shipper.address && shipper.address.toLowerCase().includes(searchTerm))
        ) ||
        load.consignees.some((consignee) =>
          (consignee.name && consignee.name.toLowerCase().includes(searchTerm)) ||
          (consignee.address && consignee.address.toLowerCase().includes(searchTerm))
        );

      const matchesDriver = selectedDriver ? load.driver === selectedDriver : true;

      return matchesSearch && matchesDriver;
    });

    setFilteredLoads(filtered);
  }, [search, loads, selectedDriver]);


  const getDriverName = (driverId) => {
    const driver = drivers.find((d) => d._id === driverId);
    return driver ? `${driver.firstName} ${driver.lastName}` : 'Unknown Driver';
  };

  const handleSelectLoad = (loadIndex) => {
    setEditingLoad(filteredLoads[loadIndex]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditingLoad({ ...editingLoad, [name]: value });
  };

  const handleDriverChange = (e) => {
    const newDriverId = e.target.value;
    setSelectedDriver(newDriverId);
    setEditingLoad({ ...editingLoad, driver: newDriverId });
  };

  const handleTruckChange = (e) => {
    const newTruckId = e.target.value;
    setSelectedTruck(newTruckId);
    setEditingLoad({ ...editingLoad, truck: newTruckId });
  };

  const handleSave = async () => {
    try {
      if (editingLoad && editingLoad._id) {
        await axios.put(`${apiUrl}/loads/${editingLoad._id}`, editingLoad, config);
        setLoads((prevLoads) =>
          prevLoads.map((load) =>
            load._id === editingLoad._id ? editingLoad : load
          )
        );
        alert('Load updated successfully');
      }
    } catch (error) {
      console.error('Error updating load:', error);
    }
  };

  const handleDelete = (loadId) => {
    setDeleteTarget(loadId); // Setăm ID-ul pentru notificare
  
    // 🔥 Dăm scroll la secțiunea de editare cu un mic delay
    setTimeout(() => {
      if (editSectionRef.current) {
        editSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 200); // Delay pentru a permite UI-ului să se actualizeze
  };
  
  useEffect(() => {
    if (deleteTarget !== null) {
      setTimeout(() => {
        if (editSectionRef.current) {
          editSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 200);
    }
  }, [deleteTarget]);
  
  
  const confirmDeleteLoad = async () => {
    if (!deleteTarget) return;
  
    try {
      await axios.delete(`${apiUrl}/loads/${deleteTarget}`, config);
      setLoads((prevLoads) => prevLoads.filter((load) => load._id !== deleteTarget));
      setEditingLoad(null);
      alert('Load deleted successfully');
    } catch (error) {
      console.error('Error deleting load:', error);
      alert('Failed to delete load.');
    }
    setDeleteTarget(null); // 🔥 Ascundem notificarea după ștergere
  };
  

  return (
    <div className={styles.ultimateloadManagerSection}>
      <h2 className={styles.titleultimateloadManager}>Load Scheduler</h2>

      <input
        type="text"
        placeholder="Search by Load Number or Driver"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className={styles.searchInputultimateloadManager}
      />

      <select
        onChange={(e) => setSelectedDriver(e.target.value)}
        value={selectedDriver}
        className={styles.selectFieldultimateloadManager}
      >
        <option value="">Filter by Driver</option>
        {drivers.map((driver) => (
          <option key={driver._id} value={driver._id}>
            {driver.firstName} {driver.lastName}
          </option>
        ))}
      </select>

      <table className={styles.ultimateloadManagerloadTable}>
        <thead>
          <tr>
            <th>Load #</th>
            <th>Broker Name</th>
            <th>Broker Address</th>
            <th>Rate</th>
            <th>Shippers</th>
            <th>Consignees</th>
            <th>Dispatcher</th>
            <th>Status</th>
            <th>Driver</th>
            <th>Truck</th>
            <th>Miles</th>
            <th>DH</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          {filteredLoads.map((load, index) => (
            <tr key={index} onClick={() => handleSelectLoad(index)} className={styles.ultimateloadManagerloadRow}>
              <td>{load.loadNumber}</td>
              <td>{load.brokerName}</td>
              <td>{load.brokerAddress}</td>
              <td>${load.rate}</td>
              <td>
                {load.shippers.map((shipper, idx) => (
                  <div key={idx}>
                    <strong>Name:</strong> {shipper.name} <br />
                    <strong>Address:</strong> {shipper.address} <br />
                    <strong>Pick-up Time:</strong> {shipper.pickUpTime ? new Date(shipper.pickUpTime).toLocaleString() : 'N/A'}
                  </div>
                ))}
              </td>
              <td>
                {load.consignees.map((consignee, idx) => (
                  <div key={idx}>
                    <strong>Name:</strong> {consignee.name} <br />
                    <strong>Address:</strong> {consignee.address} <br />
                    <strong>Delivery Time:</strong> {consignee.deliveryTime ? new Date(consignee.deliveryTime).toLocaleString() : 'N/A'}
                  </div>
                ))}
              </td>
              <td>{load.dispatcher}</td>
              <td>{load.status}</td>
              <td>{load.driver ? drivers.find(d => d._id === load.driver)?.firstName || "Unknown" : "No Driver"}</td>
              <td>{load.truck ? trucks.find(t => t._id === load.truck)?.plate || "Unknown" : "No Truck"}</td>
              <td>{load.miles}</td>
              <td>{load.dh}</td>
              <td>{load.notes}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {editingLoad ? (
  <div ref={editSectionRef} className={styles.editLoadFormultimateloadManager}>
    <h3>Edit Load</h3>
    <button onClick={() => setEditingLoad(null)} className={styles.closeButtonultimateloadManager}>
      ✕
    </button>

    {/* Load Number */}
    <label>Load #:</label>
    <input
      name="loadNumber"
      value={editingLoad.loadNumber}
      disabled // Disable edit pentru loadNumber
      className={styles.inputFieldultimateloadManager}
    />

    {/* Broker Information */}
    <label>Broker Name:</label>
    <input
      name="brokerName"
      value={editingLoad.brokerName || ''}
      onChange={handleChange}
      className={styles.inputFieldultimateloadManager}
    />

    <label>Broker Address:</label>
    <input
      name="brokerAddress"
      value={editingLoad.brokerAddress || ''}
      onChange={handleChange}
      className={styles.inputFieldultimateloadManager}
    />

    {/* Rate */}
    <label>Rate:</label>
    <input
      name="rate"
      type="number"
      value={editingLoad.rate || ''}
      onChange={handleChange}
      className={styles.inputFieldultimateloadManager}
    />

    {/* Status */}
    <label>Status:</label>
    <select
      name="status"
      value={editingLoad.status || ''}
      onChange={handleChange}
      className={styles.selectFieldultimateloadManager}
    >
              <option value="Pending">Pending</option>
              <option value="Open">Open</option>
              <option value="Refused">Refused</option>
              <option value="Assigned">Assigned</option>
              <option value="Dispatched">Dispatched</option>
              <option value="On Route">On Route</option>
              <option value="In Progress">In Progress</option>
              <option value="Delivered">Delivered</option>
              <option value="(Un)Loading">Un-Loading</option>
              <option value="Completed">Completed</option>
              <option value="Cancelled">Cancelled</option>
              <option value="In Yard">In Yard</option>

    </select>
  {/* Payment Status */}
  <label>Payment Status:</label>
          <select
            name="paymentStatus"
            value={editingLoad.paymentStatus || ''}
            onChange={handleChange}
            className={styles.selectFieldultimateloadManager}
          >
            <option value="">Select Payment Status</option>
            <option value="Not Paid">Not Paid</option>
            <option value="Pending Payment">Pending Payment</option>
            <option value="Payment in Progress">Payment in Progress</option>
            <option value="Payment Cancelled">Payment Cancelled</option>
            <option value="Paid">Paid</option>
            <option value="Paid in Installments">Paid in Installments</option>
          </select>

     {/* Driver Selector */}
     <label>Driver:</label>
          <select
            value={selectedDriver}
            onChange={handleDriverChange}
            className={styles.selectFieldultimateloadManager}
          >
            <option value="">Select Driver</option>
            {drivers.map((driver) => (
              <option key={driver._id} value={driver._id}>
                {driver.firstName} {driver.lastName}
              </option>
            ))}
          </select>

          {/* Truck Selector */}
          <label>Truck:</label>
          <select
            value={selectedTruck}
            onChange={handleTruckChange}
            className={styles.selectFieldultimateloadManager}
          >
            <option value="">Select Truck</option>
            {trucks.map((truck) => (
              <option key={truck._id} value={truck._id}>
                {truck.plate}
              </option>
            ))}
          </select>

    {/* Miles and DH */}
    <label>Miles:</label>
    <input
      name="miles"
      type="number"
      value={editingLoad.miles || ''}
      onChange={handleChange}
      className={styles.inputFieldultimateloadManager}
    />

    <label>DH:</label>
    <input
      name="dh"
      type="number"
      value={editingLoad.dh || ''}
      onChange={handleChange}
      className={styles.inputFieldultimateloadManager}
    />

    {/* Notes */}
    <label>Notes:</label>
    <textarea
      name="notes"
      value={editingLoad.notes || ''}
      onChange={handleChange}
      className={styles.textareaFieldultimateloadManager}
    />

    {/* Shippers */}
    <label>Shippers:</label>
    {editingLoad.shippers.map((shipper, index) => (
      <div key={index} className={styles.subFormultimateloadManager}>
        <label>Name:</label>
        <input
          value={shipper.name || ''}
          onChange={(e) => {
            const updatedShippers = [...editingLoad.shippers];
            updatedShippers[index].name = e.target.value;
            setEditingLoad({ ...editingLoad, shippers: updatedShippers });
          }}
          className={styles.inputFieldultimateloadManager}
        />
        <label>Address:</label>
        <input
          value={shipper.address || ''}
          onChange={(e) => {
            const updatedShippers = [...editingLoad.shippers];
            updatedShippers[index].address = e.target.value;
            setEditingLoad({ ...editingLoad, shippers: updatedShippers });
          }}
          className={styles.inputFieldultimateloadManager}
        />
        <label>Pick-up Time:</label>
        <input
          type="datetime-local"
          value={shipper.pickUpTime ? new Date(shipper.pickUpTime).toISOString().slice(0, -1) : ''}
          onChange={(e) => {
            const updatedShippers = [...editingLoad.shippers];
            updatedShippers[index].pickUpTime = new Date(e.target.value);
            setEditingLoad({ ...editingLoad, shippers: updatedShippers });
          }}
          className={styles.inputFieldultimateloadManager}
        />
      </div>
    ))}

    {/* Consignees */}
    <label>Consignees:</label>
    {editingLoad.consignees.map((consignee, index) => (
      <div key={index} className={styles.subFormultimateloadManager}>
        <label>Name:</label>
        <input
          value={consignee.name || ''}
          onChange={(e) => {
            const updatedConsignees = [...editingLoad.consignees];
            updatedConsignees[index].name = e.target.value;
            setEditingLoad({ ...editingLoad, consignees: updatedConsignees });
          }}
          className={styles.inputFieldultimateloadManager}
        />
        <label>Address:</label>
        <input
          value={consignee.address || ''}
          onChange={(e) => {
            const updatedConsignees = [...editingLoad.consignees];
            updatedConsignees[index].address = e.target.value;
            setEditingLoad({ ...editingLoad, consignees: updatedConsignees });
          }}
          className={styles.inputFieldultimateloadManager}
        />
        <label>Delivery Time:</label>
        <input
          type="datetime-local"
          value={consignee.deliveryTime ? new Date(consignee.deliveryTime).toISOString().slice(0, -1) : ''}
          onChange={(e) => {
            const updatedConsignees = [...editingLoad.consignees];
            updatedConsignees[index].deliveryTime = new Date(e.target.value);
            setEditingLoad({ ...editingLoad, consignees: updatedConsignees });
          }}
          className={styles.inputFieldultimateloadManager}
        />
      </div>
    ))}
     {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this load?"
    onConfirm={confirmDeleteLoad}
    onCancel={() => setDeleteTarget(null)}
  />
)}

    {/* Save and Delete Buttons */}
    <button onClick={handleSave} className={styles.saveButtonultimateloadManager}>Save</button>
    <button onClick={() => handleDelete(editingLoad._id)} className={styles.deleteButtonultimateloadManager}>
  Delete
</button>

  </div>
) : (
  <p>No load selected</p>
)}

    </div>
  );
};


const DriverPayManager = () => {
  const [activeFilter, setActiveFilter] = useState('');
  const [data, setData] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [payrollFiles, setPayrollFiles] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const token = sessionStorage.getItem('token');

  const config = {
      headers: {
          Authorization: `Bearer ${token}`,
      },
  };

  // ✅ Fetch Data for the Selected Filter (Drivers, Trucks, Not More Working)
  const fetchData = async () => {
      try {
          let url;
          switch (activeFilter) {
              case 'drivers':
                  url = 'https://api-backend.full-trucking-service.com/api/drivers';
                  break;
              case 'trucks':
                  url = 'https://api-backend.full-trucking-service.com/api/trucks';
                  break;
              case 'notMoreWorking':
                  url = 'https://api-backend.full-trucking-service.com/api/drivers';
                  break;
              default:
                  setData([]);
                  return;
          }

          const response = await axios.get(url, config);
          const filteredData =
              activeFilter === 'notMoreWorking'
                  ? response.data.filter((d) => d.notMoreWorking)
                  : response.data;
          setData(filteredData);
      } catch (error) {
          console.error('Error fetching data:', error);
      }
  };

  useEffect(() => {
      if (activeFilter) fetchData();
  }, [activeFilter]);

  const fetchPayrollFiles = async (entityId) => {
    try {
        const response = await axios.get(
            `https://api-backend.full-trucking-service.com/api/list-files/${entityId}`,
            config
        );

        // Filtrare pentru a preveni fișiere fără nume
        const validFiles = response.data.filter(file => file.name && file.name.trim() !== '');
        setPayrollFiles(validFiles);
    } catch (error) {
        console.error('Error fetching payroll files:', error);
    }
};

  const handleEntitySelect = (entity) => {
      setSelectedEntity(entity);
      fetchPayrollFiles(entity._id);
  };
 const handleFileDownload = async (driverId, fileName) => {
    try {
        const response = await axios.get(
            `https://api-backend.full-trucking-service.com/api/download-file/${driverId}/${fileName}`,
            {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem('token')}`
                },
                responseType: 'blob'  // Descărcare binară
            }
        );

        // ✅ Descărcare fișier direct
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); 
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.error('Error downloading file:', error);
        alert('Failed to download the file.');
    }
};




  const handleFilterChange = (filter) => {
      setActiveFilter(filter);
      setSelectedEntity(null);
      setPayrollFiles([]);
      setSearchTerm('');
  };

  const filteredData = data.filter((entity) =>
      `${entity.firstName || ''} ${entity.lastName || ''} ${entity.truckNumber || ''}`
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
  );

  return (
      <div className={styles.ultimatemanagerContainer}>
          <h2 className={styles.titleDriverPayManager}>Payroll Manager</h2>

          {/* ✅ Selectare Filtru */}
          <div className={styles.filterSectionultimatemanager}>
              <button
                  className={activeFilter === 'drivers' ? styles.activeultimatemanager : ''}
                  onClick={() => handleFilterChange('drivers')}
              >
                  Drivers
              </button>
              <button
                  className={activeFilter === 'trucks' ? styles.activeultimatemanager : ''}
                  onClick={() => handleFilterChange('trucks')}
              >
                  Trucks
              </button>
              <button
                  className={activeFilter === 'notMoreWorking' ? styles.activeultimatemanager : ''}
                  onClick={() => handleFilterChange('notMoreWorking')}
              >
                  Not More Working Drivers
              </button>
          </div>

          {/* ✅ Căutare Avansată */}
          <input
              type="text"
              placeholder="Search by name or truck number..."
              className={styles.searchBarultimatemanager}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
          />

          {/* ✅ Listă Dynamică */}
          <div className={styles.listContainerultimatemanager}>
              <ul className={styles.entityListultimatemanager}>
                  {filteredData.map((entity) => (
                      <li
                          key={entity._id}
                          onClick={() => handleEntitySelect(entity)}
                          className={
                              selectedEntity?._id === entity._id
                                  ? styles.selectedEntityultimatemanager
                                  : ''
                          }
                      >
                          {entity.firstName || entity.truckNumber}{' '}
                          {entity.lastName || ''}
                      </li>
                  ))}
              </ul>
          </div>

          {/* ✅ Payroll Files Section with startDate & endDate */}
          {selectedEntity && (
              <div className={styles.filesSectionultimatemanager}>
                  <h3>Payroll Files for: {selectedEntity.firstName || selectedEntity.truckNumber}</h3>
                  {payrollFiles.length > 0 ? (
             <ul className={styles.fileListultimatemanager}>
             {payrollFiles.map((file, index) => (
                 <li key={index}>
                     <span>{file.name ? file.name : 'N/A'}</span>
                     <p><strong>Start Date:</strong> {file.startDate ? file.startDate : 'N/A'}</p>
                     <p><strong>End Date:</strong> {file.endDate ? file.endDate : 'N/A'}</p>
                     <button 
    className={styles.downloadButtonultimateDriverPayManager} // 🔥 Adăugare clasă CSS
    onClick={() => file.name ? handleFileDownload(selectedEntity._id, file.name) : alert('Invalid file name')}
>
    Download
</button>

                 </li>
             ))}
         </ul>
         
                 
                  ) : (
                      <p>No payroll files available for this entity.</p>
                  )}
              </div>
          )}
      </div>
  );
};


const DriverPay = ({ drivers, trucks, loads, onAddDriverPay }) => {
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedLoads, setSelectedLoads] = useState([]);
  const [recurringDeductions, setRecurringDeductions] = useState([]);
  const [recurringAdditions, setRecurringAdditions] = useState([]);
  const [clientInfo, setClientInfo] = useState({
    companyName: '',
    companyAddress: '',
    email: '',
    phone: '',
  });

  
  const [week, setWeek] = useState('');
  const [customFooterText, setCustomFooterText] = useState('');
  const [useCustomFooter, setUseCustomFooter] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);


  // Configurația pentru autentificare
  const token = sessionStorage.getItem('token');
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };
  const saveTotalPay = async () => {
    if (!selectedDriver || !startDate || !endDate) {
      console.error("❌ Driver, Start Date sau End Date lipsesc!");
      return;
    }
  
    const { totalPayWithAdjustments } = calculatePay();
  
    try {
      const response = await axios.post(
        'https://api-backend.full-trucking-service.com/api/totalpays',
        {
          driverId: selectedDriver._id,
          startDate,
          endDate,
          totalWithAdjustments: totalPayWithAdjustments
        },
        config
      );
  
      if (response.status === 201) {
        console.log("✅ TotalPay saved successfully:", response.data);
      } else {
        console.error("❌ Error saving TotalPay:", response.data);
      }
    } catch (error) {
      console.error("❌ Error adding TotalPay:", error);
    }
  };
  
  useEffect(() => {
    const fetchClientInfo = async () => {
      try {
        const response = await axios.get('https://api-backend.full-trucking-service.com/api/settings', config);
        const { companyName, companyAddress, email, phone } = response.data;
        setClientInfo({ companyName, companyAddress, email, phone });
        if (customFooterText) setCustomFooterText(customFooterText);
        if (useCustomFooter !== undefined) setUseCustomFooter(useCustomFooter);
      } catch (error) {
        console.error("Error fetching client info:", error);
      }
    };

    fetchClientInfo();
  }, []);
  

  
  useEffect(() => {
    const fetchRecurringData = async () => {
        if (selectedDriver) {
            try {
                const response = await axios.get(`https://api-backend.full-trucking-service.com/api/drivers/${selectedDriver._id}`, config);
                setRecurringDeductions(response.data.recurringDeductions || []);
                setRecurringAdditions(response.data.recurringAdditions || []);
            } catch (error) {
                console.error("Error fetching recurring data for driver:", error);
            }
        } else if (selectedTruck) {
            try {
                const response = await axios.get(`https://api-backend.full-trucking-service.com/api/trucks/${selectedTruck._id}`, config);
                setRecurringDeductions(response.data.recurringDeductions || []);
                setRecurringAdditions(response.data.recurringAdditions || []);
            } catch (error) {
                console.error("Error fetching recurring data for truck:", error);
            }
        }
    };

    fetchRecurringData();
}, [selectedDriver, selectedTruck]);
const saveRecurringData = async () => {
  if (selectedDriver) {
      try {
          await axios.put(
              `https://api-backend.full-trucking-service.com/api/drivers/${selectedDriver._id}`,
              {
                  recurringDeductions,
                  recurringAdditions,
              },
              config
          );
          console.log("Recurring data saved successfully for driver.");
      } catch (error) {
          console.error("Error saving recurring data for driver:", error);
      }
  } else if (selectedTruck) {
      try {
          await axios.put(
              `https://api-backend.full-trucking-service.com/api/trucks/${selectedTruck._id}`,
              {
                  recurringDeductions,
                  recurringAdditions,
              },
              config
          );
          console.log("Recurring data saved successfully for truck.");
      } catch (error) {
          console.error("Error saving recurring data for truck:", error);
      }
  }
};

// Salvăm datele recurente la fiecare modificare în deduceri și adiții
useEffect(() => {
  saveRecurringData();
}, [recurringDeductions, recurringAdditions]);




// ✅ Selectarea unui driver resetează truckul
const handleDriverSelect = (e) => {
  const driver = drivers.find((driver) => driver._id === e.target.value);
  setSelectedDriver(driver);
  setSelectedTruck(null); // Resetăm truckul dacă se selectează un driver
};

// ✅ Selectarea unui truck resetează driverul
const handleTruckSelect = (e) => {
  const truck = trucks.find((truck) => truck._id === e.target.value);
  setSelectedTruck(truck);
  setSelectedDriver(null); // Resetăm driverul dacă se selectează un truck
};

  const handleAddDriverPay = async () => {
    if ((!selectedDriver && !selectedTruck) || !startDate || !endDate) {
        console.error('Driver/Truck, Start Date or End Date missing');
        return;
    }

    const transformedDeductions = recurringDeductions.map((ded) => ({
        amount: parseFloat(ded.amount) || 0,
        service: ded.service,
    }));

    const transformedAdditions = recurringAdditions.map((add) => ({
        amount: parseFloat(add.amount) || 0,
        service: add.service,
    }));

    const { payDetails, totalRate, totalRateWithAdjustments, totalPay } = calculatePay();

if (!totalRateWithAdjustments && totalRateWithAdjustments !== 0) {
   
    return;
}


    try {
        const response = await axios.post(
            'https://api-backend.full-trucking-service.com/api/driverpays',
            {
                driver: selectedDriver ? selectedDriver._id : null,
                truck: selectedTruck ? selectedTruck._id : null,
                startDate,
                endDate,
                recurringAddition: transformedAdditions,
                recurringDeduction: transformedDeductions,
                totalPay,
                totalWithAdjustments: totalRateWithAdjustments,
                payDetails,
                companyName: clientInfo.companyName,
         
            },
            config
        );

        if (response.status === 201) {
            console.log('DriverPay saved successfully:', response.data);
        } else {
            console.error('Error saving DriverPay:', response.data);
        }
    } catch (error) {
        console.error('Error adding driver pay:', error);
    }
};


  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'startDate') setStartDate(value);
    else setEndDate(value);
  };

  const searchLoads = () => {
    if ((!selectedDriver && !selectedTruck) || !startDate || !endDate) return;
  
    const filtered = loads.filter((load) => {
      let match = false;
      if (load.status !== 'Completed') {
        return false;
      }
      
  
      
      // Verificăm dacă șoferul selectat este șoferul principal sau parte din echipă
      if (selectedDriver) {
        match =
          load.driver?.toString() === selectedDriver._id?.toString() ||
          (Array.isArray(load.teamDrivers) &&
            load.teamDrivers.some((teamDriverId) =>
              teamDriverId.toString() === selectedDriver._id?.toString()
            ));
      }
  
      // Verificăm dacă camionul selectat este asociat cu încărcătura
      if (selectedTruck) {
        match = load.truck?.toString() === selectedTruck._id?.toString();
      }
  
      // Verificăm datele de preluare și livrare
      const hasPickupDate = load.shippers.some(
        (shipper) =>
          shipper.pickUpTime && new Date(shipper.pickUpTime) >= new Date(startDate)
      );
      const hasDeliveryDate = load.consignees.some(
        (consignee) =>
          consignee.deliveryTime && new Date(consignee.deliveryTime) <= new Date(endDate)
      );
  
      return match && hasPickupDate && hasDeliveryDate;
    });
  
   
    setFilteredLoads(filtered);
};

  
  

  const handleLoadSelection = (loadNumber) => {
    setSelectedLoads((prevSelected) =>
      prevSelected.includes(loadNumber)
        ? prevSelected.filter((num) => num !== loadNumber)
        : [...prevSelected, loadNumber]
    );
  };
  const calculatePay = () => {
    const payDetails = filteredLoads
        .filter((load) => selectedLoads.includes(load.loadNumber))
        .map((load) => {
          console.log("Processing Load:", load);
            console.log("Shippers in Load:", load.shippers);
            console.log("Consignees in Load:", load.consignees);
            const driverSettlement = selectedDriver ? selectedDriver.settlement : null;
            const truckSettlement = selectedTruck ? selectedTruck.settlement : null;
            let pay = 0;
            let payDescription = '';

            if (selectedDriver) {
                switch (driverSettlement) {
                    case 'Hourly pay':
                        pay = parseFloat(selectedDriver.hoursWorked || 0) * parseFloat(selectedDriver.settlementAmount || 0);
                        break;
                    case 'Per mile pay':
                        const driverMilesPay = parseFloat(load.miles || 0) * parseFloat(selectedDriver.normalMileRate || 0);
                        const driverDhPay = parseFloat(load.dh || 0) * parseFloat(selectedDriver.dhMileRate || 0);
                        pay = driverMilesPay + driverDhPay;
                        break;
                    case 'Fixed salary':
                        pay = parseFloat(selectedDriver.settlementAmount || 0);
                        break;
                    case 'Percentage of the load':
                        pay = (parseFloat(load.rate || 0) * parseFloat(selectedDriver.settlementAmount || 0)) / 100;
                        break;
                    case 'Team driver pay':
                        pay = parseFloat(load.rate || 0) / 2;
                        break;
                }
            }

            if (selectedTruck) {
                switch (truckSettlement) {
                    case 'Hourly pay':
                        pay = parseFloat(selectedTruck.hoursWorked || 0) * parseFloat(selectedTruck.settlementAmount || 0);
                        break;
                    case 'Per mile pay':
                        const truckMilesPay = parseFloat(load.miles || 0) * parseFloat(selectedTruck.normalMileRate || 0);
                        const truckDhPay = parseFloat(load.dh || 0) * parseFloat(selectedTruck.dhMileRate || 0);
                        pay = truckMilesPay + truckDhPay;
                        break;
                    case 'Fixed salary':
                        pay = parseFloat(selectedTruck.settlementAmount || 0);
                        break;
                    case 'Percentage of the load':
                        pay = (parseFloat(load.rate || 0) * parseFloat(selectedTruck.settlementAmount || 0)) / 100;
                        break;
                    case 'Team driver pay':
                        pay = parseFloat(load.rate || 0) / 2;
                        break;
                }
            }

            return {
                loadNumber: load.loadNumber || 'N/A',
                rate: load.rate || 0,
                pay,
                payDescription,
                miles: load.miles || 0,
                dh: load.dh || 0,
                shippers: load.shippers || [],
                consignees: load.consignees || []
            };
        });

    const totalRate = payDetails.reduce((sum, detail) => sum + parseFloat(detail.rate || 0), 0);
    let totalPay = payDetails.reduce((sum, detail) => sum + parseFloat(detail.pay || 0), 0);

    const recurringAdditionsTotal = recurringAdditions.reduce((sum, add) => sum + parseFloat(add.amount || 0), 0);
    const recurringDeductionsTotal = recurringDeductions.reduce((sum, ded) => sum + parseFloat(ded.amount || 0), 0);
    const totalPayWithAdjustments = totalPay + recurringAdditionsTotal - recurringDeductionsTotal;

    return {
        payDetails,
        totalRate,
        totalPayWithAdjustments: isNaN(totalPayWithAdjustments) ? 0 : totalPayWithAdjustments,
        totalPay
    };
};

  
  const generatePDF = async () => { 
    const { payDetails, totalRate, totalPayWithAdjustments, totalPay } = calculatePay();
    const doc = new jsPDF();

 

    // Adaugă antetul pe fiecare pagină
    const addHeader = () => {

      doc.setFontSize(12);
      doc.setTextColor("#000000");
      doc.text('Settlement', 105, 20, { align: 'center' });
      doc.setFontSize(8);
      if (week) doc.text(`Week ${week}`, 105, 35, { align: 'center' });
      if (selectedDriver) {
        doc.text(`Driver: ${selectedDriver.firstName} ${selectedDriver.lastName}`, 10, 50);
        doc.text(`Address: ${selectedDriver.address}`, 10, 55);
        doc.text(`Truck: ${selectedDriver.truckNumber || 'N/A'}`, 10, 60);
        doc.text(`Phone: ${selectedDriver.phone}`, 10, 65);
      } else if (selectedTruck) {
        doc.text(`Truck Number: ${selectedTruck.truckNumber}`, 10, 60);
      }
      doc.text(`Start Date: ${startDate}`, 150, 50);
      doc.text(`End Date: ${endDate}`, 150, 55);
    };
  
    const addFooter = () => {
      const pageHeight = doc.internal.pageSize.height;
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);

      // ✅ Dacă nu este loc, mută pe pagina următoare
      if (doc.lastAutoTable.finalY + 30 > pageHeight) {
          doc.addPage();
          addHeader();
      }

      doc.text(`Page ${pageCount}`, 10, pageHeight - 10);

      if (useCustomFooter && customFooterText) {
          doc.text(customFooterText, 105, pageHeight - 20, { align: 'center' });
      } else {
          doc.text('Thank you for your business!', 105, pageHeight - 20, { align: 'center' });
          doc.text(`${clientInfo.companyName}`, 105, pageHeight - 15, { align: 'center' });
          doc.text(`${clientInfo.companyAddress}`, 105, pageHeight - 10, { align: 'center' });
      }
  };
  
    // Adaugă antetul pe prima pagină
    addHeader();
  
    let startY = 80;
  
    // Iterează prin detalii și adaugă conținut
    payDetails.forEach((detail, index) => {
     
      // Verifică dacă este necesară o pagină nouă
      if (startY > doc.internal.pageSize.height - 40) {
        doc.addPage();
        addHeader(); // Antet pe pagina nouă
        addFooter(); // Footer pe pagina nouă
        startY = 30;
      }
  
      doc.setFontSize(8);
  
      const pickupDetails = detail.shippers.length > 0
      ? detail.shippers.map((shipper) => {
          if (!shipper.pickUpTime || isNaN(new Date(shipper.pickUpTime).getTime())) {
            return `Unknown Date - ${shipper.address || 'N/A'}`;
          }
          return `${new Date(shipper.pickUpTime).toLocaleString()} - ${shipper.address || 'N/A'}`;
        }).join('\n')
      : 'N/A';
    
    const deliveryDetails = detail.consignees.length > 0
      ? detail.consignees.map((consignee) => {
          if (!consignee.deliveryTime || isNaN(new Date(consignee.deliveryTime).getTime())) {
            return `Unknown Date - ${consignee.address || 'N/A'}`;
          }
          return `${new Date(consignee.deliveryTime).toLocaleString()} - ${consignee.address || 'N/A'}`;
        }).join('\n')
      : 'N/A';
  
      doc.autoTable({
        startY: startY,
        body: [
          [
            { content: `Load #`, styles: { fontStyle: 'bold', halign: 'left' } },
            `${index + 1}`,
            '',
          ],
          [
            { content: 'Pickup:', styles: { fontStyle: 'bold', halign: 'left' } },
            { content: pickupDetails || 'N/A', colSpan: 2 },
          ],
          [
            { content: 'Delivery:', styles: { fontStyle: 'bold', halign: 'left' } },
            { content: deliveryDetails || 'N/A', colSpan: 2 },
          ],
          [
            { content: 'Rate', styles: { fontStyle: 'bold', halign: 'left' } },
            getRateDetail(detail),
            '',
          ],
          [
            'Notes',
            detail.notes || 'No notes available',
            {
              content: `Total Pay: $${detail.pay.toFixed(2)}`,
              styles: { fontStyle: 'bold', halign: 'right' },
            },
          ],
        ],
        theme: 'grid',
        styles: { textColor: "#000000", lineWidth: 0.75, fontSize: 8, cellPadding: 1.5 },
        margin: { top: 10, left: 10, right: 10 },
        columnStyles: { 0: { halign: 'left' }, 1: { halign: 'left' }, 2: { halign: 'right' } },
      });
  
      startY = doc.lastAutoTable.finalY + 10;
    });
  
    // Adaugă totaluri și salariul fix
    if (selectedDriver && selectedDriver.settlement === 'Fixed salary') {
      startY += 20;
      doc.text(`Fixed Salary: $${totalPay.toFixed(2)}`, 10, startY);
    }
  
    // Sub-Total
    doc.setFontSize(10);
    doc.text('Sub-Total', 10, startY);
    startY += 10;
  
    doc.autoTable({
      startY: startY,
      body: [['Sub-Total', `$${totalPay.toFixed(2)}`]],
      theme: 'grid',
      styles: { textColor: "#000000", lineWidth: 0.75, fontSize: 8, cellPadding: 1.5 },
      margin: { top: 10, left: 10, right: 10 },
      columnStyles: { 0: { halign: 'left' }, 1: { halign: 'right' } },
    });
  
    // Recurring Additions
    startY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(10);
    doc.text('Recurring Additions', 10, startY);
    startY += 10;
  
    doc.autoTable({
      startY: startY,
      head: [['Service', 'Amount']],
      body: recurringAdditions.map((add) => [add.service, `$${parseFloat(add.amount || 0).toFixed(2)}`]),
      theme: 'grid',
      styles: { textColor: "#000000", lineWidth: 0.75, fontSize: 8, cellPadding: 1.5 },
      margin: { top: 10, left: 10, right: 10 },
      columnStyles: { 0: { halign: 'left' }, 1: { halign: 'right' } },
    });
  
    // Recurring Deductions
    startY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(10);
    doc.text('Recurring Deductions', 10, startY);
    startY += 10;
  
    doc.autoTable({
      startY: startY,
      head: [['Service', 'Amount']],
      body: recurringDeductions.map((ded) => [ded.service, `-$${parseFloat(ded.amount || 0).toFixed(2)}`]),
      theme: 'grid',
      styles: { textColor: "#000000", lineWidth: 0.75, fontSize: 8, cellPadding: 1.5 },
      margin: { top: 10, left: 10, right: 10 },
      columnStyles: { 0: { halign: 'left' }, 1: { halign: 'right' } },
    });
  
    // Grand Total
    startY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(10);
    doc.text(`Grand Total: $${totalPayWithAdjustments.toFixed(2)}`, 10, startY);
  
    // Adaugă footer-ul final
    addFooter();
 
    try {
      // ✅ Salvare PDF ca fișier binar corect
      const pdfBlob = doc.output('blob');  

      // ✅ Crearea unui FormData pentru upload corect
      const formData = new FormData();
      formData.append('file', pdfBlob, 'driver_payroll.pdf');
      formData.append('driverId', selectedDriver ? selectedDriver._id : '');
        formData.append('truckId', selectedTruck ? selectedTruck._id : '');
      formData.append('startDate', startDate);
      formData.append('endDate', endDate);

      // ✅ Trimiterea PDF-ului către backend
      const uploadResponse = await axios.post(
          'https://api-backend.full-trucking-service.com/api/upload-file',
          formData,
          {
              headers: {
                  'Authorization': `Bearer ${sessionStorage.getItem('token')}`
              }
          }
      );

      if (uploadResponse.status === 200) {
          alert('PDF uploaded successfully');
      } else {
          console.error('Upload failed:', uploadResponse.data);
      }
  } catch (error) {
      
  }
  await saveTotalPay(); 
      // Salvare PDF local
      doc.save('driver_payroll.pdf');

    };

        const getRateDetail = (detail) => {
  if (selectedTruck && selectedTruck.settlement) {
    switch (selectedTruck.settlement) {
      case 'Hourly pay':
        return `Truck: ${selectedTruck.hoursWorked || 0} hours * $${selectedTruck.settlementAmount || 0} per hour`;
      case 'Per mile pay':
        return `Truck: Miles ${detail.miles} * $${selectedTruck.normalMileRate || 0} + DH Miles ${detail.dh} * $${selectedTruck.dhMileRate || 0}`;
      case 'Fixed salary':
        return `Fixed Salary (Truck) - $${selectedTruck.settlementAmount || 0}`;
      case 'Percentage of the load':
        return `Truck: ${selectedTruck.settlementAmount}% of $${detail.rate || 0}`;
      case 'Team driver pay':
        return `Truck Team Driver: Load Rate $${detail.rate || 0} / 2 (Each driver receives half)`;
      default:
        return `Truck rate for load: $${detail.rate || 0}`;
    }
  }
  
  if (selectedDriver && selectedDriver.settlement) {
    switch (selectedDriver.settlement) {
      case 'Hourly pay':
        return `Driver: ${selectedDriver.hoursWorked || 0} hours * $${selectedDriver.settlementAmount || 0} per hour`;
      case 'Per mile pay':
        return `Driver: Miles ${detail.miles} * $${selectedDriver.normalMileRate || 0} + DH Miles ${detail.dh} * $${selectedDriver.dhMileRate || 0}`;
      case 'Fixed salary':
        return `Fixed Salary (Driver) - $${selectedDriver.settlementAmount || 0}`;
      case 'Percentage of the load':
        return `Driver: ${selectedDriver.settlementAmount}% of $${detail.rate || 0}`;
      case 'Team driver pay':
        return `Driver Team: Load Rate $${detail.rate || 0} / 2`;
      default:
        return `Driver rate for load: $${detail.rate || 0}`;
    }
  }
  
  return `Rate: $${detail.rate || 0}`;
};





  const removeRecurring = (type, index) => {
    if (type === 'deduction') {
      setRecurringDeductions(recurringDeductions.filter((_, i) => i !== index));
    } else {
      setRecurringAdditions(recurringAdditions.filter((_, i) => i !== index));
    }
  };

  // Funcție pentru adăugarea deducerilor și adițiilor recurente
  const addDeduction = () => {
    setRecurringDeductions([...recurringDeductions, { amount: 0, service: '' }]);
  };

  const addAddition = () => {
    setRecurringAdditions([...recurringAdditions, { amount: 0, service: '' }]);
  };

  return (
    <div className={styles.ultimatedriverPaySection}>
      <h2 className={styles.titledriverPayultimatedriverPay}>Payroll</h2>
      <div className={styles.formGroupdriverPayultimatedriverPay}>
    <label>Select Driver</label>
    <select onChange={handleDriverSelect} value={selectedDriver ? selectedDriver._id : ''} className={styles.selectFielddriverPayultimate}>
        <option value="">Select Driver</option>
        {drivers.map((driver) => (
            <option key={driver._id} value={driver._id}>
                {driver.firstName} {driver.lastName}
            </option>
        ))}
    </select>
</div>

{/* Selectare Truck */}
<div className={styles.formGroupultimatedriverPay}>
    <label>Select Truck</label>
    <select onChange={handleTruckSelect} value={selectedTruck ? selectedTruck._id : ''} className={styles.selectFieldultimatedriverPay}>
        <option value="">Select Truck</option>
        {trucks.map((truck) => (
            <option key={truck._id} value={truck._id}>
                Truck {truck.truckNumber}
            </option>
        ))}
    </select>
</div>

      {(selectedDriver || selectedTruck) && (
        <div className={styles.driverDetailsultimatedriverPay}>
          <h3 className={styles.subtitleultimatedriverPay}>
            {selectedDriver
              ? `Driver: ${selectedDriver.firstName} ${selectedDriver.lastName}`
              : `Truck: ${selectedTruck.truckNumber}`}
          </h3>
   
          <div className={styles.formGroupultimatedriverPay}>
            <label>Week</label>
            <input
              type="text"
              value={week}
              onChange={(e) => setWeek(e.target.value)}
              placeholder="Enter week (optional)"
              className={styles.inputFieldultimatedriverPay}
            />
          </div>
 
          <div className={styles.formRowultimatedriverPay}>
            <div className={styles.formGroupultimatedriverPay}>
              <label>Start Date</label>
              <input
                type="date"
                name="startDate"
                value={startDate}
                onChange={handleDateChange}
                className={styles.inputFieldultimatedriverPay}
              />
            </div>
            <div className={styles.formGroupultimatedriverPay}>
              <label>End Date</label>
              <input
                type="date"
                name="endDate"
                value={endDate}
                onChange={handleDateChange}
                className={styles.inputFieldultimatedriverPay}
              />
            </div>
          </div>
          <button onClick={searchLoads} className={styles.actionButtonultimatedriverPay}>
            Search
          </button>
          {filteredLoads.length > 0 && (
            <div className={styles.loadDetailsultimatedriverPay}>
              <h3 className={styles.subtitleultimatedriverPay}>Load Details</h3>
              <ul className={styles.loadListultimatedriverPay}>
              {filteredLoads.map((load, index) => (
  <li key={index} className={styles.loadItemultimatedriverPay}>
    <input
      type="checkbox"
      checked={selectedLoads.includes(load.loadNumber)}
      onChange={() => handleLoadSelection(load.loadNumber)}
    />
    <strong>Load #:</strong> {load.loadNumber || 'N/A'} <br />
    <strong>Pick Up:</strong> {
  load.shippers.length > 0 && load.shippers[0].pickUpTime
    ? new Date(load.shippers[0].pickUpTime).toLocaleString()
    : 'N/A'
} <br />
<strong>Delivery:</strong> {
  load.consignees.length > 0 && load.consignees[0].deliveryTime
    ? new Date(load.consignees[0].deliveryTime).toLocaleString()
    : 'N/A'
} <br />
    <strong>Rate:</strong> ${parseFloat(load.rate || 0).toFixed(2)} <br />
  </li>
))}

              </ul>

              <button onClick={calculatePay} className={styles.actionButtonultimatedriverPay}>
                Calculate
              </button>
               <div className={styles.recurringSectionultimatedriverPay}>
            <div className={styles.formGroupultimatedriverPay}>
              <label>Recurring Deduction</label>
              {recurringDeductions.map((deduction, index) => (
                <div key={index} className={styles.recurringItemultimatedriverPay}>
                  <input
                    type="number"
                    value={deduction.amount}
                    onChange={(e) => {
                      const updatedDeductions = [...recurringDeductions];
                      updatedDeductions[index].amount = e.target.value;
                      setRecurringDeductions(updatedDeductions);
                    }}
                    placeholder="Amount"
                    className={styles.inputFieldultimatedriverPay}
                  />
                  <input
                    type="text"
                    value={deduction.service}
                    onChange={(e) => {
                      const updatedDeductions = [...recurringDeductions];
                      updatedDeductions[index].service = e.target.value;
                      setRecurringDeductions(updatedDeductions);
                    }}
                    placeholder="Service"
                    className={styles.inputFieldultimatedriverPay}
                  />
                  <button onClick={() => removeRecurring('deduction', index)} className={styles.removeButtonultimatedriverPay}>X</button>
                </div>
              ))}
              <button onClick={addDeduction} className={styles.addButtonultimatedriverPay}>Add Deduction</button>
            </div>

            <div className={styles.formGroupultimatedriverPay}>
              <label>Recurring Addition</label>
              {recurringAdditions.map((addition, index) => (
                <div key={index} className={styles.recurringItemultimatedriverPay}>
                  <input
                    type="number"
                    value={addition.amount}
                    onChange={(e) => {
                      const updatedAdditions = [...recurringAdditions];
                      updatedAdditions[index].amount = e.target.value;
                      setRecurringAdditions(updatedAdditions);
                    }}
                    placeholder="Amount"
                    className={styles.inputFieldultimatedriverPay}
                  />
                  <input
                    type="text"
                    value={addition.service}
                    onChange={(e) => {
                      const updatedAdditions = [...recurringAdditions];
                      updatedAdditions[index].service = e.target.value;
                      setRecurringAdditions(updatedAdditions);
                    }}
                    placeholder="Service"
                    className={styles.inputFieldultimatedriverPay}
                  />
                  <button onClick={() => removeRecurring('addition', index)} className={styles.removeButtonultimatedriverPay}>X</button>
                </div>
              ))}

                  <button onClick={addAddition} className={styles.addButtonultimatedriverPay}>
                    Add Addition
                  </button>
                </div>
              </div>
              <button
                onClick={async () => {
                  await handleAddDriverPay();
                  generatePDF();
                }}
                className={styles.actionButtonultimatedriverPay}
              >
                Save and Preview
              </button>
            </div>
          )}
        </div>
      )}
    </div>
    
  );
};



const FuelReport = ({ drivers, trucks }) => {
  
  const [fuelData, setFuelData] = useState({
    driverId: '',
    truckId: '',
    paymentMethod: '',
    location: '',
    fuelSubtotal: 0,
    otherCosts: 0,
    grandTotal: 0,
  });
  const [fuelReports, setFuelReports] = useState([]);
  const [selectedReports, setSelectedReports] = useState([]);
  const [isEditing, setIsEditing] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteTarget, setDeleteTarget] = useState(null);


  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const token = sessionStorage.getItem('token');

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  useEffect(() => {
    fetchFuelReports();
  }, []);

  const fetchFuelReports = async () => {
    try {
      const response = await axios.get(`${apiUrl}/fuel-reports`, config);
      setFuelReports(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
     
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFuelData((prev) => ({
        ...prev,
        [name]: value,
        grandTotal:
            name === 'fuelSubtotal' || name === 'otherCosts'
                ? parseFloat(prev.fuelSubtotal || 0) + parseFloat(prev.otherCosts || 0)
                : prev.grandTotal,
    }));
};


  const addFuelEntry = async () => {
    try {
        const entry = {
            ...fuelData,
            grandTotal: parseFloat(fuelData.fuelSubtotal || 0) + parseFloat(fuelData.otherCosts || 0),
        };

        console.log("🚀 SENDING FUEL REPORT:", entry); // 🔹 DEBUGGING

        const response = await axios.post(`${apiUrl}/fuel-reports`, entry, config);
        if (response.status === 201 && response.data?.data) {
            alert('Fuel entry added successfully');
            setFuelReports((prev) => [...prev, response.data.data]);
            setFuelData({
                driverId: '',
                truckId: '',
                paymentMethod: '',
                location: '',
                fuelSubtotal: 0,
                otherCosts: 0,
                grandTotal: 0,
            });
        } else {
            alert('Failed to add fuel entry.');
        }
    } catch (error) {
        console.error('❌ Error adding fuel entry:', error);
        alert('Failed to add fuel entry.');
    }
};


  const editFuelEntry = async () => {
    try {
      const response = await axios.put(`${apiUrl}/fuel-reports/${isEditing}`, fuelData, config);
      if (response.status === 200) {
        alert('Fuel entry updated successfully');
        setFuelReports((prev) =>
          prev.map((entry) => (entry._id === isEditing ? response.data.data : entry))
        );
        setIsEditing(null); // Resetează modul de editare
        setFuelData({
          driverId: '',
          truckId: '',
          paymentMethod: '',
          location: '',
          fuelSubtotal: 0,
          otherCosts: 0,
          grandTotal: 0,
        });
      }
    } catch (error) {
      console.error('Error editing fuel entry:', error);
      alert('Failed to edit fuel entry.');
    }
  };
  
  const handleEditClick = (entry) => {
    setIsEditing(entry._id); // Setează ID-ul raportului pentru editare
    setFuelData({
      driverId: entry.driverId?._id || '', // ID-ul șoferului
      truckId: entry.truckId?._id || '', // ID-ul camionului
      paymentMethod: entry.paymentMethod || '',
      location: entry.location || '',
      fuelSubtotal: entry.fuelSubtotal || 0,
      otherCosts: entry.otherCosts || 0,
      grandTotal: entry.grandTotal || 0,
      
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  

  const confirmDeleteFuelEntry = async (id) => {
    try {
      await axios.delete(`${apiUrl}/fuel-reports/${id}`, config);
      setFuelReports((prev) => prev.filter((entry) => entry._id !== id));
    } catch (error) {
      console.error('Error deleting fuel entry:', error);
      alert('Failed to delete fuel entry.');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  
  const handleExport = () => {
    // Filtrăm doar rapoartele selectate
    const selectedData = fuelReports
      .filter((report) => selectedReports.includes(report._id))
      .map((report) => {
        // Găsim șoferul și camionul asociat folosind ID-uri
        const driver = drivers.find((d) => String(d._id) === String(report.driverId?._id || report.driverId));
        const truck = trucks.find((t) => String(t._id) === String(report.truckId?._id || report.truckId));
  
        // Structurăm datele pentru export
        return {
          Driver: driver ? `${driver.firstName} ${driver.lastName}` : 'N/A', // Numele complet al șoferului
          Truck: truck ? truck.truckNumber : 'N/A', // Numărul camionului
          Location: report.location || 'N/A',
          'Fuel Subtotal': report.fuelSubtotal ? `$${report.fuelSubtotal.toFixed(2)}` : 'N/A',
          'Other Costs': report.otherCosts ? `$${report.otherCosts.toFixed(2)}` : 'N/A',
          'Grand Total': report.grandTotal ? `$${report.grandTotal.toFixed(2)}` : 'N/A',
          'Created At': report.createdAt ? new Date(report.createdAt).toLocaleString() : 'N/A',
        };
      });
  
    if (selectedData.length === 0) {
      alert('No reports selected for export!');
      return;
    }
  
    // Exportăm în Excel
    const worksheet = XLSX.utils.json_to_sheet(selectedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Fuel Report');
    XLSX.writeFile(workbook, 'SelectedFuelReport.xlsx');
  };
  
  
  

  const handleSelect = (id) => {
    setSelectedReports((prev) =>
      prev.includes(id) ? prev.filter((reportId) => reportId !== id) : [...prev, id]
    );
  };

  const selectAll = () => {
    if (selectedReports.length === fuelReports.length) {
      setSelectedReports([]);
    } else {
      setSelectedReports(fuelReports.map((report) => report._id));
    }
  };

  const filteredReports = fuelReports.filter((report) => {
    const driver = drivers.find((d) => d._id === report.driverId);
    const truck = trucks.find((t) => t._id === report.truckId);
    return (
      (driver ? `${driver.firstName} ${driver.lastName}`.toLowerCase() : '').includes(searchTerm.toLowerCase()) ||
      (truck ? truck.truckNumber.toString() : '').includes(searchTerm.toLowerCase()) ||
      report.location.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const currentReports = filteredReports.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className={styles.fuelReportContainer}>
      <h2 className={styles.titlefuelReport}>Fuel Report</h2>
      <div className={styles.formContainerfuelReport}>
  <label>Driver:</label>
  <select name="driverId" value={fuelData.driverId || ''} onChange={handleInputChange} className={styles.customSelectFuelReport}>
  <option value="">Select Driver</option>
    {drivers.map((driver) => (
      <option key={driver._id} value={driver._id}>
        {driver.firstName} {driver.lastName}
      </option>
    ))}
  </select>

  <label>Truck:</label>
  <select name="truckId" value={fuelData.truckId} onChange={handleInputChange} className={styles.customSelectFuelReport}>
    <option value="">Select Truck</option>
    {trucks.map((truck) => (
      <option key={truck._id} value={truck._id}>
        {truck.truckNumber}
      </option>
    ))}
  </select>


        <label>Payment Method:</label>
        <select name="paymentMethod" value={fuelData.paymentMethod} onChange={handleInputChange} className={styles.customSelectFuelReport}>
          <option value="">Select Payment Method</option>
          <option value="cash">Cash</option>
          <option value="private">Private</option>
          <option value="card">Card</option>
        </select>

        <label>Location:</label>
        <input
          type="text"
          name="location"
          value={fuelData.location}
          onChange={handleInputChange}
        />

        <label>Fuel Subtotal:</label>
        <input
          type="number"
          name="fuelSubtotal"
          value={fuelData.fuelSubtotal}
          onChange={handleInputChange}
        />

        <label>Other Costs:</label>
        <input
          type="number"
          name="otherCosts"
          value={fuelData.otherCosts}
          onChange={handleInputChange}
        />

        <label>Grand Total:</label>
        <input type="number" name="grandTotal" value={fuelData.grandTotal} readOnly />

        <button onClick={isEditing ? editFuelEntry : addFuelEntry} className={styles.submitButtonfuelReport}>
    {isEditing ? 'Update Fuel Entry' : 'Add Fuel Entry'}
</button>

{isEditing && (
    <button onClick={() => setIsEditing(null)} className={styles.cancelButtonfuelReport}>
      Cancel
    </button>
)}

</div>

<div className={styles.buttonGroupfuelReport}>
    <button onClick={handleExport} className={styles.exportButtonfuelReport}>Export to Excel</button>
    <button onClick={selectAll} className={styles.selectAllButtonfuelReport}>Select All</button>
</div>


   {/* Tabel */}
<table className={styles.fuelReportTable}>
  <thead className={styles.tableHeaderfuelReport}>
    <tr>
      <th>Select</th>
      <th>Driver</th>
      <th>Truck</th>
      <th>Location</th>
      <th>Fuel Subtotal</th>
      <th>Other Costs</th>
      <th>Grand Total</th>
      <th>Created At</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody className={styles.tableBodyfuelReport}>
    {currentReports.map((entry) => (
      <tr key={entry._id} className={styles.tableRowfuelReport}>
        <td>
          <input
            type="checkbox"
            checked={selectedReports.includes(entry._id)}
            onChange={() => handleSelect(entry._id)}
          />
        </td>
        <td>{entry.driverId ? `${entry.driverId.firstName} ${entry.driverId.lastName}` : 'N/A'}</td>
        <td>{entry.truckId ? entry.truckId.truckNumber : 'N/A'}</td>
        <td>{entry.location || 'N/A'}</td>
        <td>{entry.fuelSubtotal ? `$${entry.fuelSubtotal.toFixed(2)}` : 'N/A'}</td>
        <td>{entry.otherCosts ? `$${entry.otherCosts.toFixed(2)}` : 'N/A'}</td>
        <td>{entry.grandTotal ? `$${entry.grandTotal.toFixed(2)}` : 'N/A'}</td>
        <td>{entry.createdAt ? new Date(entry.createdAt).toLocaleString() : 'N/A'}</td>
        <td>
        {deleteTarget && (
  <DeleteNotifications
    message="Are you sure you want to delete this fuel report?"
    onConfirm={() => confirmDeleteFuelEntry(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}

          <button onClick={() => handleEditClick(entry)} className={styles.editButtonfuelReport}>Edit</button>
          <button 
  onClick={() => setDeleteTarget(entry._id)} 
  className={styles.deleteButtonfuelReport}
>
  Delete
</button>

        </td>
      </tr>
    ))}
  </tbody>
</table>

      {/* Paginare */}
      <div className={styles.paginationContainerfuelReport}>
  <button 
    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
    className={styles.prevButtonfuelReport}
  >
    Previous
  </button>
  
  <button 
    onClick={() => setCurrentPage((prev) => prev + 1)}
    disabled={currentPage * rowsPerPage >= filteredReports.length}
    className={styles.nextButtonfuelReport}
  >
    Next
  </button>
</div>
    </div>
  );
};

const AddLoad = ({
  onClose,
  onAddLoad,
  drivers,
  trucks,
  trailers,
  brokers,
  shippers,
  consignees,
  dispatchers,
  currentUserId,
  currentUserRole
}) => {
  
  const [loadData, setLoadData] = useState({
    loadNumber: "",
    dispatcher: "",
    brokerName: "",
    brokerAddress: "",
    rate: "",
    shippers: [],
    consignees: [],
    dispatcher: "",
    driver: "",
    teamDrivers: [],
    truck: "",
    trailers: "",
    status: "",
    paymentStatus: "Not Paid", 
    miles: "",
    dh: "",
    notes: "",
  });

  const [shippersSuggestions, setShippersSuggestions] = useState([]);
  const [consigneesSuggestions, setConsigneesSuggestions] = useState([]);
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
  const apiUrl = 'https://api-backend.full-trucking-service.com/api'; // URL-ul backend-ului
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,  // Adaugă tokenul cu prefixul Bearer
      'Content-Type': 'application/json',
    },
    withCredentials: true,  // Trimite cookies pentru autentificare
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoadData((prevState) => ({
      ...prevState,
      [name]: value || "",
    }));
  };

  const handleDriverChange = (e) => {
    setLoadData((prevState) => ({
      ...prevState,
      driver: e.target.value,
    }));
  };

  // Selectare șoferi pentru echipă (Team Drivers)
  const handleTeamDriverChange = (selectedOptions) => {
    setLoadData((prevState) => ({
      ...prevState,
      teamDrivers: selectedOptions ? selectedOptions.map((option) => option.value) : [],
    }));
  };

  const handleBrokerSelect = (e) => {
    const selectedBrokerName = e.target.value;
    const selectedBroker = brokers.find(
      (b) => b.brokerName === selectedBrokerName
    );
    setLoadData((prevState) => ({
      ...prevState,
      brokerName: selectedBrokerName,
      brokerAddress: selectedBroker ? selectedBroker.address : "",
    }));
  };
  useEffect(() => {
    const fetchSuggestions = async () => {
      try {
        const shippersResponse = await axios.get(`${apiUrl}/shippers`, config);
        const consigneesResponse = await axios.get(`${apiUrl}/consignees`, config);
        setShippersSuggestions(shippersResponse.data);
        setConsigneesSuggestions(consigneesResponse.data);
      } catch (error) {
        console.error("Error fetching shippers and consignees:", error);
      }
    };

    fetchSuggestions();
  }, []);
  const handleShipperSelect = (index, selectedName) => {
    const selectedShipper = shippersSuggestions.find(
      (shipper) => shipper.shipperName === selectedName
    );
    
    if (selectedShipper) {
      const newShippers = [...loadData.shippers];
      newShippers[index] = {
        ...newShippers[index],
        name: selectedShipper.shipperName,
        address: selectedShipper.shipperAddress, // setează adresa corectă
      };
      setLoadData((prevState) => ({ ...prevState, shippers: newShippers }));
    }
  };
  
  const handleConsigneeSelect = (index, selectedName) => {
    const selectedConsignee = consigneesSuggestions.find(
      (consignee) => consignee.consigneeName === selectedName
    );
  
    if (selectedConsignee) {
      const newConsignees = [...loadData.consignees];
      newConsignees[index] = {
        ...newConsignees[index],
        name: selectedConsignee.consigneeName,
        address: selectedConsignee.consigneeAddress, // setează adresa corectă
      };
      setLoadData((prevState) => ({ ...prevState, consignees: newConsignees }));
    }
  };
  
  
  

  const handleAddShipper = () => {
    setLoadData((prevState) => ({
      ...prevState,
      shippers: [...prevState.shippers, { name: "", address: "", pickUpTime: "" }], // folosește 'name' și 'address'
    }));
  };
  
  const handleAddConsignee = () => {
    setLoadData((prevState) => ({
      ...prevState,
      consignees: [...prevState.consignees, { name: "", address: "", deliveryTime: "" }], // folosește 'name' și 'address'
    }));
  };
  

  const handleRemoveShipper = (index) => {
    setLoadData((prevState) => ({
      ...prevState,
      shippers: prevState.shippers.filter((_, i) => i !== index),
    }));
  };

  const handleRemoveConsignee = (index) => {
    setLoadData((prevState) => ({
      ...prevState,
      consignees: prevState.consignees.filter((_, i) => i !== index),
    }));
  };

  const handleShipperChange = (index, e) => {
    const { name, value } = e.target;
    const newShippers = [...loadData.shippers];
    newShippers[index][name] = value;
    setLoadData((prevState) => ({ ...prevState, shippers: newShippers }));
  };

  const handleConsigneeChange = (index, e) => {
    const { name, value } = e.target;
    const newConsignees = [...loadData.consignees];
    newConsignees[index][name] = value;
    setLoadData((prevState) => ({ ...prevState, consignees: newConsignees }));
  };

  const calculateMiles = async () => {
    const allAddresses = [
      ...loadData.shippers.map((s) => s.address),
      ...loadData.consignees.map((c) => c.address),
    ];

    if (allAddresses.length < 2) return;

    try {
      let totalMiles = 0;
      for (let i = 0; i < allAddresses.length - 1; i++) {
        const url = `${apiUrl}/calculate-distance?origins=${encodeURIComponent(
          allAddresses[i]
        )}&destinations=${encodeURIComponent(allAddresses[i + 1])}&apiKey=${apiKey}`;

        const response = await axios.get(url);
        const data = response.data;

        if (data.distance) {
          const distanceInMeters = data.distance.value;
          totalMiles += distanceInMeters * 0.000621371;
        }
      }
      setLoadData((prevState) => ({ ...prevState, miles: totalMiles.toFixed(2) }));
    } catch (error) {
      console.error("Error calculating miles:", error);
    }
  };
  useEffect(() => {
    // Căutăm dispatcher-ul curent bazat pe clientId, în cazul în care utilizatorul autentificat este client
  
  
    if (
      currentUserRole === 'dispatcher' &&
      Array.isArray(dispatchers) &&
      dispatchers.length > 0 &&
      currentUserId
    ) {
      // Dacă `currentUserId` este al clientului, găsim dispatcher-ul bazat pe `clientId`
      const currentDispatcher = dispatchers.find(d => d.clientId === currentUserId);
      console.log("Current Dispatcher:", currentDispatcher);
  
      if (currentDispatcher) {
        setLoadData(prev => ({
          ...prev,
          dispatcher: currentDispatcher._id
        }));
      }
    }
  }, [currentUserId, dispatchers, currentUserRole]);
  
  
  
  useEffect(() => {
    if (loadData.shippers.length && loadData.consignees.length) {
      calculateMiles();
    }
  }, [loadData.shippers, loadData.consignees]);
  const handleSubmit = async () => {
    try {
      if (!loadData.driver && !loadData.truck) {
        alert("You must select either a Driver or a Truck before submitting.");
        return;
    }
      if (
        !loadData.loadNumber.trim() ||
        loadData.shippers.length === 0 ||
        loadData.consignees.length === 0
      ) {
        alert("Load Number, Driver or Truck, Shipper, and Consignee are mandatory fields.");
        return;
      }
  
      // Validare câmp rate (doar numere și punct zecimal)
      if (loadData.rate && !/^\d+(\.\d{1,2})?$/.test(loadData.rate)) {
        alert("Rate must be a valid number (e.g., 200 or 200.00).");
        return;
      }
  
      // Validare câmpuri de tip ObjectId
      if (loadData.truck && !/^[0-9a-fA-F]{24}$/.test(loadData.truck)) {
        alert("Invalid Truck ID.");
        return;
      }
  
      const dataToSend = {
        ...loadData,
        clientId,
        truck: loadData.truck || null, // Trimite null dacă truck nu este selectat
        trailers: loadData.trailers || null, // Similar pentru trailers
        paymentStatus: loadData.paymentStatus || "Not Paid",
        
      };

       // ✅ Verifică dacă există load-uri active pentru acest driver sau truck
    const incompleteLoadsResponse = await axios.get(`${apiUrl}/loads/incomplete`, config);
    const incompleteLoads = incompleteLoadsResponse.data || [];

    // Verificare pentru driver
    if (loadData.driver) {
      const driverHasActiveLoad = incompleteLoads.some(load => load.driver === loadData.driver);
      if (driverHasActiveLoad) {
        alert("This driver already has an active load! Please complete the existing load first.");
        return;
      }
    }

    // Verificare pentru truck
    if (loadData.truck) {
      const truckHasActiveLoad = incompleteLoads.some(load => load.truck === loadData.truck);
      if (truckHasActiveLoad) {
        alert("This truck already has an active load! Please complete the existing load first.");
        return;
      }
    }
  
      // Salvează shipperii
      for (const shipper of loadData.shippers) {
        const existingShipper = shippersSuggestions.find(
          (s) => s.shipperName === shipper.name && s.shipperAddress === shipper.address
        );
        if (!existingShipper) {
          await axios.post(
            `${apiUrl}/shippers`,
            { shipperName: shipper.name, shipperAddress: shipper.address },
            config
          );
        }
      }
  
      // Salvează consignees
      for (const consignee of loadData.consignees) {
        const existingConsignee = consigneesSuggestions.find(
          (c) => c.consigneeName === consignee.name && c.consigneeAddress === consignee.address
        );
        if (!existingConsignee) {
          await axios.post(
            `${apiUrl}/consignees`,
            { consigneeName: consignee.name, consigneeAddress: consignee.address },
            config
          );
        }
      }
  
      // Salvează încărcătura (load)
      const response = await axios.post(`${apiUrl}/loads`, dataToSend, config);
  
      if (response.status === 201) {
        alert("Load added successfully.");
  
        // Resetează formularul
        setLoadData({
          loadNumber: "",
          dispatcher: "",
          brokerName: "",
          brokerAddress: "",
          rate: "",
          equipment: "",
          driver: "",
          teamDrivers: [],
          truck: "",
          trailers: "",
          status: "",
          shippers: [],
          consignees: [],
          miles: "",
          dh: "",
          notes: "",
        });
  
        console.log("Load and related shippers/consignees added successfully");
        window.location.href = '?tab=add-new-load';
      }
    } catch (error) {
      console.error("Error adding load:", error);
      const errorMessage =
        error.response?.data?.error || "There was an error saving the load.";
      alert(errorMessage);
    }
  };
  
  const handleRateChange = (e) => {
    const value = e.target.value;
    // Păstrează doar numerele și punctul
    const filteredValue = value.replace(/[^0-9.]/g, "");
    setLoadData((prevState) => ({
      ...prevState,
      rate: filteredValue,
    }));
  };
  

  const saveBrokersShippersConsignees = async () => {
    try {
      const brokerExists = brokers.some(
        (broker) => broker.brokerName === loadData.brokerName
      );
      if (!brokerExists) {
        await axios.post(`${apiUrl}/brokers`, {
          brokerName: loadData.brokerName,
          brokerAddress: loadData.brokerAddress,
        }, config);
      }

      const shipperExists = shippers.some(
        (shipper) => shipper.shipperName === loadData.shipperName
      );
      if (!shipperExists) {
        await axios.post(`${apiUrl}/shippers`, {
          shipperName: loadData.shipperName,
          shipperAddress: loadData.shipperAddress,
        }, config);
      }

      const consigneeExists = consignees.some(
        (consignee) => consignee.consigneeName === loadData.consigneeName
      );
      if (!consigneeExists) {
        await axios.post(`${apiUrl}/consignees`, {
          consigneeName: loadData.consigneeName,
          consigneeAddress: loadData.consigneeAddress,
        }, config);
      }

      console.log("All brokers, shippers, and consignees saved successfully");
    } catch (error) {
      console.error("Error saving brokers, shippers, or consignees:", error);
      throw error;
    }
  };
  const [isLoading, setIsLoading] = useState(false);

  
  const handleCancel = () => {
    onClose();
  };
  return (
    <div className={styles.ultimateaddloadsectionContainer}>
      <h2 className={styles.titleultimateaddload}>Add New Load</h2>
      <form className={styles.loadFormultimateaddload}>
        <div className={styles.formRowultimateaddload}>
          <div className={styles.formGroupultimateaddload}>
            <label>Load Number</label>
            <input
              name="loadNumber"
              value={loadData.loadNumber}
              onChange={handleChange}
              placeholder="Load Number"
              required
              className={styles.inputFieldultimateaddload}
            />
          </div>
          <div className={styles.formGroupultimateaddload}>
          <label>Dispatcher</label>
          <select
  name="dispatcher"
  value={loadData.dispatcher}
  onChange={handleChange}
  className={styles.selectFieldultimateaddload}
  disabled={currentUserRole === 'dispatcher'}
  required
>
  {currentUserRole === 'dispatcher' ? (
    dispatchers.length > 0 ? (
      <option value={currentUserId}>
        {
          dispatchers.find(d => d.clientId === currentUserId)?.firstName
        } {
          dispatchers.find(d => d.clientId === currentUserId)?.lastName
        }
      </option>
    ) : (
      <option>Loading...</option>
    )
  ) : (
    <>
      <option value="">Select Dispatcher</option>
      {dispatchers.map((dispatcher) => (
        <option key={dispatcher._id} value={dispatcher._id}>
          {dispatcher.firstName} {dispatcher.lastName}
        </option>
      ))}
    </>
  )}
</select>

        </div>


        </div>

        <div className={styles.formRowultimateaddload}>
          <div className={styles.formGroupultimateaddload}>
            <label>Broker Name</label>
            <input
              list="brokers-list"
              name="brokerName"
              value={loadData.brokerName}
              onChange={handleBrokerSelect}
              placeholder="Broker Name"
              required
              className={styles.inputFieldultimateaddload}
            />
            <datalist id="brokers-list">
              {brokers.map((broker) => (
                <option key={broker._id} value={broker.brokerName} />
              ))}
            </datalist>
          </div>
          <div className={styles.formGroupultimateaddload}>
            <label>Broker Address</label>
            <input
              name="brokerAddress"
              value={loadData.brokerAddress}
              onChange={handleChange}
              placeholder="Broker Address"
              required
              className={styles.inputFieldultimateaddload}
            />
          </div>
        </div>

        <div className={styles.formRowultimateaddload}>
        <div className={styles.formGroupultimateaddload}>
  <label>Rate</label>
  <input
    name="rate"
    value={loadData.rate}
    onChange={handleRateChange}
    placeholder="Rate"
    required
    className={styles.inputFieldultimateaddload}
  />
</div>
          <div className={styles.formGroupultimateEquipmentaddload}>
            <label>Equipment</label>
            <select
              name="equipment"
              value={loadData.equipment}
              onChange={handleChange}
              className={styles.selectFieldEquipmentultimateaddload}
            >
              <option value="">Select Equipment</option>
              <option value="Dry Van">Dry Van</option>
              <option value="53 Van">53 Van</option>
              <option value="53' Reefer">53 Reefer</option>
              <option value="Air Freight">Air Freight</option>
              <option value="Airride/Logistical Van">Airride/Logistical Van</option>
              <option value="Any Equipment">Any Equipment</option>
              <option value="Beam">Beam</option>
              <option value="Cargo Van (1 Ton)">Cargo Van</option>
              <option value="Conestoga">Conestoga</option>
              <option value="Convertible Hopper">Convertible Hopper</option>
              <option value="Conveyor Belt">Conveyor Belt</option>
              <option value="Curtain Siders">Curtain Siders</option>
              <option value="Curtain Van">Curtain Van</option>
              <option value="Double Drop">Double Drop</option>
              <option value="Drive Away">Drive Away</option>
              <option value="Flat Intermodal">Flat Intermodal</option>
              <option value="Flat or Step Deck">Flat or Step Deck</option>
              <option value="Flat with Tarps">Flat with Tarps</option>
              <option value="Flatbed">Flatbed</option>
              <option value="Flatbed Air-Ride">Flatbed Air-Ride</option>
              <option value="Flatbed Blanket Wrapped">Flatbed Blanket Wrapped</option>
              <option value="Flatbed or Van">Flatbed or Van</option>
              <option value="Haul and Tow Unit">Haul and Tow Unit</option>
              <option value="Hazardous Material Load">Hazardous Material Load</option>
              <option value="Landoll Flatbed">Landoll Flatbed</option>
              <option value="Live Bottom Trailer">Live Bottom Trailer</option>
              <option value="Load-Out">Load-Out</option>
              <option value="Lowboy">Lowboy</option>
              <option value="Lowboy over-dimension load">Lowboy over-dimension load</option>
              <option value="Maxi or Double Flat Trailers">Maxi or Double Flat Trailers</option>
              <option value="Maxi/Double Flat Trailer">Maxi/Double Flat Trailer</option>
              <option value="Moving Van">Moving Van</option>
              <option value="Multi-Axle Heavy Hauler">Multi-Axle Heavy Hauler</option>
              <option value="Pneumatic">Pneumatic</option>
              <option value="Power Only">Power Only</option>
              <option value="Reefer Pallet Exchange">Reefer Pallet Exchange</option>
              <option value="Refrigerated Carrier">Refrigerated Carrier</option>
              <option value="Removable Goose Neck">Removable Goose Neck</option>
              <option value="Removable Goose Neck & Multi-Axle Heavy Haulers">Removable Goose Neck & Multi-Axle Heavy Haulers</option>
              <option value="RGN Extendable">RGN Extendable</option>
              <option value="Step Deck"></option>
              <option value="Straight Van">Straight Van</option>
              <option value="Tandem Van">Tandem Van</option>
              <option value="Tanker">Tanker</option>
              <option value="Team Driver Needed">Team Driver Needed</option>
              <option value="Van">Van</option>
              <option value="Van Air-Ride">Van Air-Ride</option>
              <option value="Van intermodal">Van intermodal</option>
              <option value="Van or Flatbed">Van or Flatbed</option>
              <option value="Van or Reefer">Van or Reefer</option>
              <option value="Van Pallet Exchange">Van Pallet Exchange</option>
              <option value="Vented Insulated Van">Vented Insulated Van</option>
              <option value="Vented Van">Vented Van</option>
              <option value="Walking Floor">Walking Floor</option>
            </select>
          </div>
        </div>

        <div className={styles.formRowultimateaddload}>
          <div className={styles.formGroupultimateDriveraddload}>
            <label>Driver</label>
            <select
              name="driver"
              value={loadData.driver}
              onChange={handleChange}
              required
              className={styles.selectFieldultimateaddload}
            >
              <option value="">Select Driver</option>
              {drivers.map((driver, index) => (
                <option key={index} value={driver._id}>
                  {driver.firstName} {driver.lastName}
                </option>
              ))}
            </select>
          </div>
          <div className={styles.formGroupultimateTeamDriversaddload}>
            <label>Team Drivers</label>
            <Select
              isMulti
              options={drivers.map((driver) => ({
                value: driver._id,
                label: `${driver.firstName} ${driver.lastName}`,
              }))}
              onChange={handleTeamDriverChange}
              className={styles.selectFieldultimateaddload}
              placeholder="Select Team Drivers"
            />
          </div>
          <div className={styles.formGroupultimateTruckaddload}>
            <label>Truck</label>
            <select
              name="truck"
              value={loadData.truck}
              onChange={handleChange}
              className={styles.selectFieldultimateaddload}
            >
              <option value="">Select Truck</option>
              {trucks.map((truck, index) => (
                <option key={index} value={truck._id}>
                  {truck.truckNumber}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className={styles.formGroupultimateTraileraddload}>
  <label>Trailer</label>
  <select
    name="trailer"
    value={loadData.trailer}
    onChange={handleChange}
    className={styles.selectFieldultimateaddload}
  >
    <option value="">Select Trailer</option>
    {Array.isArray(trailers) && trailers.map((trailer) => (
  <option key={trailer._id} value={trailer._id}>
    {trailer.trailerNumber}
  </option>
))}

  </select>
</div>


 
        <div className={styles.formRowultimateaddload}>
          <div className={styles.formGroupultimateStatusaddload}>
            <label>Status</label>
            <select
              name="status"
              value={loadData.status}
              onChange={handleChange}
              required
              className={styles.selectFieldultimateStatusaddload}
            >
              <option value="">Select Status</option>
              <option value="Pending">Pending</option>
              <option value="Open">Open</option>
              <option value="Refused">Refused</option>
              <option value="Assigned">Assigned</option>
              <option value="Dispatched">Dispatched</option>
              <option value="On Route">On Route</option>
              <option value="In Progress">In Progress</option>
              <option value="Delivered">Delivered</option>
              <option value="(Un)Loading">Un-Loading</option>
              <option value="Completed">Completed</option>
              <option value="Cancelled">Cancelled</option>
              <option value="In Yard">In Yard</option>

            </select>
          </div>
        </div>

        <div className={styles.formGroupultimatePaymentStatusaddload}>
  <label>Payment Status</label>
  <select
    name="paymentStatus"
    value={loadData.paymentStatus}
    onChange={handleChange}
    className={styles.selectFieldultimatePaymentStatusaddload}
    required
  >
    <option value="">Select Payment Status</option>
    <option value="Not Paid">Not Paid</option>
    <option value="Pending Payment">Pending Payment</option>
    <option value="Payment in Progress">Payment in Progress</option>
    <option value="Payment Cancelled">Payment Cancelled</option>
    <option value="Paid">Paid</option>
    <option value="Paid in Installments">Paid in Installments</option>
  </select>
</div>


   {/* Shippers Section */}
<div className={styles.sectionultimateaddload}>
  <h3>Shippers</h3>
  {loadData.shippers.map((shipper, index) => (
    <div key={index} className={styles.formGroupultimateaddload}>
      <input
        name="name"
        list={`shipper-suggestions-${index}`}
        value={shipper.name}
        onChange={(e) => {
          handleShipperChange(index, e);
          handleShipperSelect(index, e.target.value); // adaugă această linie pentru a asigura completarea adresei
        }}
        placeholder="Shipper Name"
        className={styles.inputFieldultimateaddload}
      />
      <datalist id={`shipper-suggestions-${index}`}>
        {shippersSuggestions.map((sugg) => (
          <option key={sugg._id} value={sugg.shipperName} />
        ))}
      </datalist>
      <input
        name="address"
        value={shipper.address}
        onChange={(e) => handleShipperChange(index, e)}
        placeholder="Shipper Address"
        className={styles.inputFieldultimateaddload}
      />
      <input
        name="pickUpTime"
        type="datetime-local"
        value={shipper.pickUpTime}
        onChange={(e) => handleShipperChange(index, e)}
        className={styles.inputFieldultimateaddload}
      />
 <button
        type="button"
        onClick={() => handleRemoveShipper(index)}
        className={styles.removeButtonShipperultimateaddload} // ✅ Adăugat clasa
      >
        Remove
      </button>
    </div>
  ))}
  <button
    type="button"
    onClick={handleAddShipper}
    className={styles.addButtonShipperultimateaddload} // ✅ Adăugat clasa
  >
    Add Shipper
  </button>
</div>


{/* Consignees Section */}
<div className={styles.sectionultimateaddload}>
  <h3>Consignees</h3>
  {loadData.consignees.map((consignee, index) => (
    <div key={index} className={styles.formGroupultimateaddload}>
      <input
        name="name"
        list={`consignee-suggestions-${index}`}
        value={consignee.name}
        onChange={(e) => {
          handleConsigneeChange(index, e);
          handleConsigneeSelect(index, e.target.value); // adaugă această linie pentru a asigura completarea adresei
        }}
        placeholder="Consignee Name"
        className={styles.inputFieldultimateaddload}
      />
      <datalist id={`consignee-suggestions-${index}`}>
        {consigneesSuggestions.map((sugg) => (
          <option key={sugg._id} value={sugg.consigneeName} />
        ))}
      </datalist>
      <input
        name="address"
        value={consignee.address}
        onChange={(e) => handleConsigneeChange(index, e)}
        placeholder="Consignee Address"
        className={styles.inputFieldultimateaddload}
      />
      <input
        name="deliveryTime"
        type="datetime-local"
        value={consignee.deliveryTime}
        onChange={(e) => handleConsigneeChange(index, e)}
        className={styles.inputFieldultimateaddload}
      />
      <button
        type="button"
        onClick={() => handleRemoveConsignee(index)}
        className={styles.removeButtonConsigneeultimateaddload} // ✅ Adăugat clasa
      >
        Remove
      </button>
    </div>
  ))}
  <button
    type="button"
    onClick={handleAddConsignee}
    className={styles.addButtonConsigneeultimateaddload} // ✅ Adăugat clasa
  >
    Add Consignee
  </button>
</div>

        <div className={styles.formRowultimateaddload}>
          <div className={styles.formGroupultimateaddload}>
            <label>Miles</label>
            <input
              name="miles"
              value={loadData.miles}
              onChange={handleChange}
              placeholder="Miles"
              className={styles.inputFieldultimateaddload}
            />
          </div>
          <div className={styles.formGroupultimateaddload}>
            <label>DH</label>
            <input
              name="dh"
              value={loadData.dh}
              onChange={handleChange}
              placeholder="DH"
              className={styles.inputFieldultimateaddload}
            />
          </div>
        </div>

        <div className={styles.formGroupultimateaddload}>
          <label>Notes</label>
          <textarea
            name="notes"
            value={loadData.notes}
            onChange={handleChange}
            placeholder="Notes"
            className={styles.textareaFieldultimateaddload}
          ></textarea>
        </div>

        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimateaddload}>
          Add New Load
        </button>
        <button type="button" onClick={handleCancel} className={styles.closeBtnultimateaddload}>
          Cancel
        </button>
      </form>
    
</div>
);
};

const IFTA = () => {
  const [iftaData, setIftaData] = useState({
    fuelPurchasedState: "",
    fuelPrice: "",
    milesDrivenState: "",
    milesDriven: "",
    fuelLoaded: "",
    fuelTaxPaid: ""
  });

  const [reports, setReports] = useState([]);
  const [selectedReports, setSelectedReports] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectAll, setSelectAll] = useState(false);

  const apiUrl = "https://api-backend.full-trucking-service.com/api";
  const token = sessionStorage.getItem("token");

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  const states = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia",
    "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts",
    "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
    "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
    "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
    "Wisconsin", "Wyoming", "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Nova Scotia",
    "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Argentina", "Bolivia", "Brazil", "Chile", "Colombia",
    "Ecuador", "Guyana", "Paraguay", "Peru", "Suriname", "Uruguay", "Venezuela"
  ];

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      const response = await axios.get(`${apiUrl}/ifta`, config);
      setReports(response.data);
    } catch (error) {
      console.error("❌ Error fetching reports:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIftaData({ ...iftaData, [name]: value || "" });
  };

  const handleSaveAndDownload = async () => {
    try {
      const { fuelPurchasedState, milesDrivenState, fuelPrice, fuelLoaded, milesDriven } = iftaData;

      if (!fuelPurchasedState || !milesDrivenState || !fuelPrice || !fuelLoaded || !milesDriven) {
        alert("⚠️ All fields are required!");
        return;
      }

      const payload = {
        fuelPurchasedState,
        milesDrivenState,
        fuelPrice: parseFloat(fuelPrice),
        fuelLoaded: parseFloat(fuelLoaded),
        milesDriven: parseFloat(milesDriven),
      };

      const fuelTaxPaid = (payload.fuelPrice * payload.fuelLoaded) / payload.milesDriven;
      payload.fuelTaxPaid = parseFloat(fuelTaxPaid).toFixed(2);

      const response = await axios.post(`${apiUrl}/ifta`, payload, config);

      if (response.status === 201) {
        fetchReports();
        generatePDF(response.data.result);
      } else {
        console.error("❌ Error saving IFTA report:", response.data);
      }

    } catch (error) {
      console.error("❌ Error generating IFTA report:", error);
    }
  };

  const generatePDF = (data) => {
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text("IFTA Report", 10, 10);

    doc.autoTable({
      startY: 20,
      head: [["Field", "Value"]],
      body: [
        ["Fuel Purchased State", data.fuelPurchasedState],
        ["Fuel Price ($/gal)", data.fuelPrice],
        ["Miles Driven State", data.milesDrivenState],
        ["Miles Driven", data.milesDriven],
        ["Fuel Loaded (gal)", data.fuelLoaded],
        ["Fuel Tax Paid", `$${data.fuelTaxPaid}`],
        ["Created At", new Date(data.createdAt).toLocaleString()]
      ]
    });

    doc.save(`IFTA_Report_${Date.now()}.pdf`);
  };

  const exportToExcel = () => {
    const selectedData = reports
      .filter(report => selectedReports.includes(report._id))
      .map(({ fuelPurchasedState, milesDrivenState, fuelPrice, fuelConsumed, fuelLoaded, milesDriven, fuelTaxPaid, createdAt }) => ({
        fuelPurchasedState, milesDrivenState, fuelPrice, fuelConsumed, fuelLoaded, milesDriven, fuelTaxPaid, createdAt
      }));

    const ws = XLSX.utils.json_to_sheet(selectedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "IFTA Reports");
    XLSX.writeFile(wb, "IFTA_Reports.xlsx");
  };

  const exportSelectedToPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text("Selected IFTA Reports", 10, 10);

    const selectedData = reports
      .filter(report => selectedReports.includes(report._id))
      .map(({ fuelPurchasedState, milesDrivenState, fuelPrice, fuelLoaded, milesDriven, fuelTaxPaid, createdAt }) => [
        fuelPurchasedState, milesDrivenState, `$${fuelPrice}`, milesDriven, fuelLoaded, `$${fuelTaxPaid}`, new Date(createdAt).toLocaleString()
      ]);

    doc.autoTable({
      startY: 20,
      head: [["Fuel State", "Miles State", "Fuel Price", "Miles", "Fuel Loaded", "Fuel Tax Paid", "Created At"]],
      body: selectedData,
    });

    doc.save("Selected_IFTA_Reports.pdf");
  };

  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    setSelectedReports(selectAll ? [] : reports.map(report => report._id));
  };

  return (
    <div>
      <h2>IFTA Fuel Tax Reporting</h2>

      <input
        type="text"
        placeholder="🔎 Search reports..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

<label>Fuel Purchased State</label>
      <select name="fuelPurchasedState" value={iftaData.fuelPurchasedState} onChange={handleChange}>
        <option value="">Select State</option>
        {states.map((state, index) => (
          <option key={index} value={state}>{state}</option>
        ))}
      </select>

      <label>Fuel Price ($/gal)</label>
      <input type="number" name="fuelPrice" value={iftaData.fuelPrice} onChange={handleChange} />

      <label>Miles Driven State</label>
      <select name="milesDrivenState" value={iftaData.milesDrivenState} onChange={handleChange}>
        <option value="">Select State</option>
        {states.map((state, index) => (
          <option key={index} value={state}>{state}</option>
        ))}
      </select>

      <label>Miles Driven</label>
      <input type="number" name="milesDriven" value={iftaData.milesDriven} onChange={handleChange} />

      <label>Fuel Loaded (gal)</label>
      <input type="number" name="fuelLoaded" value={iftaData.fuelLoaded} onChange={handleChange} />

      <button onClick={handleSaveAndDownload}>Save & Download PDF</button>
      <button onClick={exportToExcel}>Export to Excel</button>
      <button onClick={exportSelectedToPDF}>Export Selected as PDF</button>

      <table>
        <thead>
          <tr>
            <th><input type="checkbox" checked={selectAll} onChange={toggleSelectAll} /></th>
            <th>Fuel State</th>
            <th>Miles State</th>
            <th>Fuel Price</th>
            <th>Miles</th>
            <th>Fuel Loaded</th>
            <th>Fuel Tax Paid</th>
            <th>Created At</th>
          </tr>
        </thead>
        <tbody>
          {reports
            .filter(report => report.fuelPurchasedState.toLowerCase().includes(searchQuery.toLowerCase()))
            .map(report => (
              <tr key={report._id}>
                <td><input type="checkbox" checked={selectedReports.includes(report._id)} onChange={() => setSelectedReports([...selectedReports, report._id])} /></td>
                <td>{report.fuelPurchasedState}</td>
                <td>{report.milesDrivenState}</td>
                <td>${report.fuelPrice}</td>
                <td>{report.milesDriven}</td>
                <td>{report.fuelLoaded}</td>
                <td>${report.fuelTaxPaid}</td>
                <td>{new Date(report.createdAt).toLocaleString()}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};


const Settings = ({ updateUserSettings, drivers = [], handleUpdateDriver }) => {
  const [updatedSettings, setUpdatedSettings] = useState({
    companyName: '',
    companyAddress: '',
    firstName: '',
    lastName: '',
    mcNumber: '',
    phone: '',
    fax: '',
    email: '',
    password: '',
    subscriptionType: '',
    contractStart: '',
    package: '',
    contractEnd: '',
    notes: ''
  });

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedTrucks, setSelectedTrucks] = useState([]);
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [driverEmail, setDriverEmail] = useState('');
  const [driverPassword, setDriverPassword] = useState('');
  const [subscriptionInfo, setSubscriptionInfo] = useState({
    paymentType: '',
    expirationDate: ''
  });

  const [isTwoFactorEnabled, setIsTwoFactorEnabled] = useState(false);
  const [twoFactorWarning, setTwoFactorWarning] = useState(false);
  

   
  const [dispatchers, setDispatchers] = useState([]);
  const [accountings, setAccountings] = useState([]);
  const [selectedRole, setSelectedRole] = useState('dispatcher');
  const [newAccountFirstName, setNewAccountFirstName] = useState('');
  const [newAccountLastName, setNewAccountLastName] = useState('');
  const [newAccountEmail, setNewAccountEmail] = useState('');
  const [newAccountPhone, setNewAccountPhone] = useState('');
  const [newAccountAddress, setNewAccountAddress] = useState('');
  const [newAccountDOB, setNewAccountDOB] = useState('');
  const [newAccountSalary, setNewAccountSalary] = useState('');
  const [newAccountPassword, setNewAccountPassword] = useState('');
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [deleteTarget, setDeleteTarget] = useState(null);


  const token = sessionStorage.getItem('token');
  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${apiUrl}/settings`, config);
      const settings = response.data;

      setUpdatedSettings({
        companyName: settings.companyName || '',
        companyAddress: settings.companyAddress || '',
        firstName: settings.firstName || '',
        lastName: settings.lastName || '',
        mcNumber: settings.mcNumber || '',
        phone: settings.phone || '',
        fax: settings.fax || '',
        email: settings.email || '',
        password: settings.password || '',
        subscriptionType: settings.subscriptionType || '',
        contractStart: settings.contractStart ? settings.contractStart.split('T')[0] : '',
        contractEnd: settings.contractEnd ? settings.contractEnd.split('T')[0] : '',
        package: settings.package || '',
        notes: settings.notes || ''
      });

      setSubscriptionInfo({
        subscriptionType: settings.subscriptionType || 'N/A',
        contractEnd: settings.contractEnd ? settings.contractEnd.split('T')[0] : 'N/A',
        package: settings.package || 'N/A',
      });

      setIsTwoFactorEnabled(settings.twoFactorAuthEnabled || false);
      setTwoFactorWarning(!settings.twoFactorAuthEnabled);
    } catch (error) {
      console.error('Failed to fetch settings:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedSettings({ ...updatedSettings, [name]: value });
  };
  const handleSaveSettings = async () => {
    if (password && password !== confirmPassword) {
        alert('Passwords do not match!');
        return;
    }

    // Validare format parolă
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@!#$%^&*])[A-Za-z\d@!#$%^&*]{12,}$/;
    if (password && !passwordRegex.test(password)) {
        alert('Password must be at least 12 characters long, contain an uppercase letter, a number, and a special character (@!#$%^&*).');
        return;
    }

    setIsSaving(true);

    try {
        const updatedData = { ...updatedSettings };
        // Include parola doar dacă este setată
        if (password) {
            updatedData.password = password;
        }

        await updateUserSettings(updatedData); // trimite doar datele relevante
        await fetchSettings();

        if (password) {
            alert('Password changed successfully. Please log in again.');
            sessionStorage.removeItem('token');
            window.location.href = '/login';
        } else {
            alert('Settings updated successfully');
        }
    } catch (error) {
        console.error('Error updating settings:', error);
        alert('Failed to update settings. Please try again.');
    } finally {
        setIsSaving(false);
    }
};

const handleDriverSelection = (driverId) => {
  setSelectedDrivers((prevSelected) =>
    prevSelected.includes(driverId)
      ? prevSelected.filter((id) => id !== driverId)
      : [...prevSelected, driverId]
  );
};

const handleTruckSelection = (truckId) => {
  setSelectedTrucks((prevSelected) =>
    prevSelected.includes(truckId)
      ? prevSelected.filter((id) => id !== truckId)
      : [...prevSelected, truckId]
  );
};


    
  const handleDriverUpdate = () => {
    if (!selectedDriver) return;

    const updatedDriver = {
      ...selectedDriver,
      email: driverEmail,
      password: driverPassword,
      isBlocked: false,
    };

    axios.put(`${apiUrl}/drivers/${selectedDriver._id}`, updatedDriver, config)
      .then(() => {
        alert('Driver information has been updated!');
      })
      .catch(error => {
        console.error('Error updating driver:', error);
        alert('Failed to update driver.');
      });
  };

  const handleBlockDriver = () => {
    if (!selectedDriver) return;

    const updatedDriver = { ...selectedDriver, isBlocked: true };
    handleUpdateDriver(updatedDriver);
    alert('Driver account has been blocked!');
  };

  const handleSelectDriver = (driverId) => {
    const driver = drivers.find((d) => d._id === driverId);
    setSelectedDriver(driver);
    setDriverEmail(driver?.email || '');
    setDriverPassword('');
  };


  const handleEnableTwoFactorAuth = () => {
    axios.post(`${apiUrl}/enable-two-factor`, { method: 'email' }, config)
      .then(() => {
        alert('Two-Factor Authentication via Email enabled. You will receive a code during login.');
        setIsTwoFactorEnabled(true);
        setTwoFactorWarning(false);
      })
      .catch(error => {
        console.error('Error enabling Two-Factor Authentication:', error);
        alert('Failed to enable Two-Factor Authentication.');
      });
  };

  const handleDisableTwoFactorAuth = () => {
    axios.post(`${apiUrl}/disable-two-factor`, {}, config)
      .then(() => {
        alert('Two-Factor Authentication has been disabled!');
        setIsTwoFactorEnabled(false);
        setTwoFactorWarning(true);
      })
      .catch(error => {
        console.error('Error disabling Two-Factor Authentication:', error);
        alert('Failed to disable Two-Factor Authentication.');
      });
  };

  useEffect(() => {
    fetchClientData();  
    fetchDispatchers();
    fetchAccountings();
  }, []);

  const [clientData, setClientData] = useState({});

  const fetchClientData = async () => {
    try {
      const clientId = localStorage.getItem('clientId'); // ✅ Asigură-te că este corect
      if (!clientId) {
        console.error("⚠️ Client ID is missing in localStorage!");
        return;
      }
  
      console.log(`📡 Fetching client data for clientId: ${clientId}`); // ✅ Debugging
  
      const response = await axios.get(`${apiUrl}/clients/${clientId}`, config); // 🔥 Schimbăm endpoint-ul
      setClientData(response.data);
      
      console.log("✅ Client data received:", response.data); // ✅ Debugging
  
    } catch (error) {
      console.error('❌ Failed to fetch client data:', error);
    }
  };
  

const fetchDispatchers = async () => {
  try {
    const clientId = localStorage.getItem('clientId'); // ✅ Ia clientId corect
    if (!clientId) {
      console.error("⚠️ Client ID is missing!");
      return;
    }

    const response = await axios.get(`${apiUrl}/dispatchers?clientId=${clientId}`, config);
    // ✅ Asigură-te că șoferii, camioanele și permisiunile sunt incluse
    const dispatchersWithDetails = response.data.map(dispatcher => ({
      ...dispatcher,
      drivers: dispatcher.drivers || [], // Asigură că avem array
      trucks: dispatcher.trucks || [], // Asigură că avem array
      permissions: dispatcher.permissions || [] // Asigură că avem array
    }));

    setDispatchers(dispatchersWithDetails);
  } catch (error) {
    console.error('Error fetching dispatchers:', error);
  }
};

const fetchAccountings = async () => {
  try {
    const clientId = localStorage.getItem('clientId'); // ✅ Ia clientId corect
    if (!clientId) {
      console.error("⚠️ Client ID is missing!");
      return;
    }

    const response = await axios.get(`${apiUrl}/accountings?clientId=${clientId}`, config);
    const accountingsWithDetails = response.data.map(accounting => ({
      ...accounting,
      drivers: accounting.drivers || [], // Asigură că avem array
      trucks: accounting.trucks || [], // Asigură că avem array
      permissions: accounting.permissions || [] // Asigură că avem array
    }));

    setAccountings(accountingsWithDetails);
  } catch (error) {
    console.error('Error fetching accountings:', error);
  }
};


const handleSelectAccount = (account) => {
  setSelectedAccount(account);
  setPermissions(account.permissions || []);
};

const handlePermissionChange = (module) => {
  setPermissions((prevPermissions) =>
    prevPermissions.includes(module)
      ? prevPermissions.filter((perm) => perm !== module)
      : [...prevPermissions, module]
  );
};

const handleSavePermissions = async () => {
  if (!selectedAccount) return;

  try {
    await axios.put(`${apiUrl}/set-permissions/${selectedAccount._id}`, {
      permissions,
      role: selectedAccount.role,
    }, config);

    alert(`${selectedAccount.role} permissions updated successfully!`);
    selectedAccount.role === 'dispatcher' ? fetchDispatchers() : fetchAccountings();
  } catch (error) {
    console.error('Error updating permissions:', error);
    alert('Failed to update permissions.');
  }
};

const handleCreateDispatcherOrAccounting = async () => {
  const clientId = localStorage.getItem("clientId");

  const newAccountData = {
    firstName: newAccountFirstName,
    lastName: newAccountLastName,
    email: newAccountEmail,
    phone: newAccountPhone,
    address: newAccountAddress,
    dateOfBirth: newAccountDOB,
    salaryDetails: newAccountSalary,
    password: newAccountPassword,
    role: selectedRole,
    clientId,
    permissions: permissions,
    drivers: selectedDrivers, // ✅ Adaugă șoferii direct la creare
    trucks: selectedTrucks, // ✅ Adaugă camioanele direct la creare
  };

  console.log("📌 Trimitere dispatcher/accounting:", newAccountData);

  try {
    const response = await axios.post(
      `${apiUrl}/${selectedRole === "dispatcher" ? "dispatchers" : "accountings"}`,
      newAccountData,
      config
    );
    console.log("✅ Dispatcher/accounting created:", response.data);
    alert(`${selectedRole} created successfully!`);
    selectedRole === "dispatcher" ? fetchDispatchers() : fetchAccountings();
    clearAccountForm();
  } catch (error) {
    console.error(`❌ Error creating ${selectedRole}:`, error.response?.data || error.message);
    alert(`Failed to create ${selectedRole}. Check console for details.`);
  }
};

  const handleEditAccount = (account) => {
    setSelectedAccount(account);
    setNewAccountFirstName(account.firstName);
    setNewAccountLastName(account.lastName);
    setNewAccountEmail(account.email);
    setNewAccountPhone(account.phone);
    setNewAccountAddress(account.address);
    setNewAccountDOB(account.dateOfBirth);
    setNewAccountSalary(account.salaryDetails);
    setSelectedRole(account.role);
    setSelectedDrivers(account.drivers ? account.drivers.map(driver => driver._id) : []);

    // ✅ Preselectează camioanele existente
    setSelectedTrucks(account.trucks ? account.trucks.map(truck => truck._id) : []);
  
    // ✅ Preselectează permisiunile existente
    setPermissions(account.permissions || []);
  };

  const handleUpdateAccount = async () => {
    if (!selectedAccount) return;

    const updatedData = {
      firstName: newAccountFirstName,
      lastName: newAccountLastName,
      email: newAccountEmail,
      phone: newAccountPhone,
      address: newAccountAddress,
      dateOfBirth: newAccountDOB,
      salaryDetails: newAccountSalary,
    };

    try {
      await axios.put(`${apiUrl}/${selectedRole === 'dispatcher' ? 'dispatchers' : 'accountings'}/${selectedAccount._id}`, updatedData, config);
      alert(`${selectedRole === 'dispatcher' ? 'Dispatcher' : 'Accounting'} updated successfully!`);
      selectedRole === 'dispatcher' ? fetchDispatchers() : fetchAccountings();
      clearAccountForm();
    } catch (error) {
      console.error(`Error updating ${selectedRole}:`, error);
      alert(`Failed to update ${selectedRole}`);
    }
  };

  const requestDeleteAccount = (account) => {
    setDeleteTarget(account); // Stocăm contul pentru confirmare
  };
  
  const confirmDeleteAccount = async () => {
    if (!deleteTarget) return;
  
    const accountId = deleteTarget._id;
    const accountType = deleteTarget.role === 'dispatcher' ? 'dispatchers' : 'accountings';
  
    try {
      await axios.delete(`${apiUrl}/${accountType}/${accountId}`, config);
      alert(`${deleteTarget.role} deleted successfully!`);
      deleteTarget.role === 'dispatcher' ? fetchDispatchers() : fetchAccountings();
    } catch (error) {
      console.error(`Error deleting ${deleteTarget.role}:`, error);
      alert(`Failed to delete ${deleteTarget.role}`);
    }
    setDeleteTarget(null); // 🔥 Ascundem notificarea după ștergere
  };
  

  const clearAccountForm = () => {
    setNewAccountFirstName('');
    setNewAccountLastName('');
    setNewAccountEmail('');
    setNewAccountPhone('');
    setNewAccountAddress('');
    setNewAccountDOB('');
    setNewAccountSalary('');
    setNewAccountPassword('');
    setSelectedAccount(null);
  };

  return (
    <div className={styles.settingsSection}>
      {twoFactorWarning && (
        <div className={styles.twoFactorWarningsettings}>
          <p style={{ color: 'red' }}>Please set up Two-Factor Authentication to enhance your account security!</p>
        </div>
      )}

      <h2 className={styles.titlesettings}>Settings</h2>
      <form className={styles.settingsFormsettings}>
        <label>Company Name</label>
        <input
          name="companyName"
          value={updatedSettings.companyName || ''}
          onChange={handleChange}
          placeholder="Company Name"
          className={styles.inputFieldsettings}
        />

        <label>Company Address</label>
        <input
          name="companyAddress"
          value={updatedSettings.companyAddress || ''}
          onChange={handleChange}
          placeholder="Company Address"
          className={styles.inputFieldsettings}
        />

        <label>First Name</label>
        <input
          name="firstName"
          value={updatedSettings.firstName || ''}
          onChange={handleChange}
          placeholder="First Name"
          className={styles.inputFieldsettings}
        />

        <label>Last Name</label>
        <input
          name="lastName"
          value={updatedSettings.lastName || ''}
          onChange={handleChange}
          placeholder="Last Name"
          className={styles.inputFieldsettings}
        />

        <label>MC Number</label>
        <input
          name="mcNumber"
          value={updatedSettings.mcNumber || ''}
          onChange={handleChange}
          placeholder="MC Number"
          className={styles.inputFieldsettings}
        />

        <label>Phone Number</label>
        <input
          name="phone"
          value={updatedSettings.phone || ''}
          onChange={handleChange}
          placeholder="Phone Number"
          className={styles.inputFieldsettings}
        />

<label>Fax Number</label>
<input
  name="fax"
  value={updatedSettings.fax || ''}
  onChange={handleChange}
  placeholder="Fax Number"
  className={styles.inputFieldsettings}
/>

        <label>Email</label>
        <input
          name="email"
          value={updatedSettings.email || ''}
          onChange={handleChange}
          placeholder="Email"
          className={styles.inputFieldsettings}
        />

        <label>New Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="New Password"
          className={styles.inputFieldsettings}
        />

        <label>Confirm Password</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm Password"
          className={styles.inputFieldsettings}
        />

        <button type="button" onClick={handleSaveSettings} className={styles.submitButtonClientsettings}>
          Save Settings
        </button>
      </form>
    
           
<h3 className={styles.subtitleAccountultimateAccount}>Account Management</h3>
<select onChange={e => setSelectedRole(e.target.value)} className={styles.selectFieldAccountsettings}>
  <option value="dispatcher">Dispatcher</option>
  <option value="accounting">Accounting</option>
</select>

<form className={styles.accountFormsettings}>
  <label>First Name</label>
  <input
    type="text"
    value={newAccountFirstName}
    onChange={e => setNewAccountFirstName(e.target.value)}
    placeholder="First Name"
    className={styles.inputFieldAccountsettings}
  />

  <label>Last Name</label>
  <input
    type="text"
    value={newAccountLastName}
    onChange={e => setNewAccountLastName(e.target.value)}
    placeholder="Last Name"
    className={styles.inputFieldAccountsettings}
  />

  <label>Email</label>
  <input
    type="email"
    value={newAccountEmail}
    onChange={e => setNewAccountEmail(e.target.value)}
    placeholder="Email"
    className={styles.inputFieldAccountsettings}
  />

  <label>Phone</label>
  <input
    type="text"
    value={newAccountPhone}
    onChange={e => setNewAccountPhone(e.target.value)}
    placeholder="Phone"
    className={styles.inputFieldAccountsettings}
  />

  <label>Address</label>
  <input
    type="text"
    value={newAccountAddress}
    onChange={e => setNewAccountAddress(e.target.value)}
    placeholder="Address"
    className={styles.inputFieldAccountsettings}
  />

  <label>Date of Birth</label>
  <input
    type="date"
    value={newAccountDOB}
    onChange={e => setNewAccountDOB(e.target.value)}
    placeholder="Date of Birth"
    className={styles.inputFieldAccountsettings}
  />

  <label>Salary Details</label>
  <input
    type="text"
    value={newAccountSalary}
    onChange={e => setNewAccountSalary(e.target.value)}
    placeholder="Salary Details"
    className={styles.inputFieldAccountsettings}
  />

  <label>Password</label>
  <input
    type="password"
    value={newAccountPassword}
    onChange={e => setNewAccountPassword(e.target.value)}
    placeholder="Password"
    className={styles.inputFieldAccountsettings}
  />

<h4>Select Drivers</h4>
<div>
  {drivers.map((driver) => (
    <label key={driver._id} style={{ display: "block" }}>
      <input
        type="checkbox"
        checked={selectedDrivers.includes(driver._id)}
        onChange={() => handleDriverSelection(driver._id)}
      />
      {driver.firstName} {driver.lastName}
    </label>
  ))}
</div>

<h4>Select Trucks</h4>
<div>
  {trucks.map((truck) => (
    <label key={truck._id} style={{ display: "block" }}>
      <input
        type="checkbox"
        checked={selectedTrucks.includes(truck._id)}
        onChange={() => handleTruckSelection(truck._id)}
      />
      {truck.truckNumber} - {truck.licensePlate}
    </label>
  ))}
</div>



 <h3>Set Permissions</h3>
  <div className={styles.permissionsGrid}>
    {[

      { label: 'Accounting Manager', value: 'accounting-manager' },
      { label: 'Payroll', value: 'driver-pay' },
      { label: 'Payroll Manager', value: 'driverpay-manager' },
      { label: 'Fuel Report', value: 'fuel-report' },
      { label: 'Drivers', value: 'drivers' },
      { label: 'Fleet', value: 'trucks' },
      { label: 'Trailers', value: 'trailers' },
      { label: 'Shippers', value: 'shippers' },
      { label: 'Consignees', value: 'consignee' },
      { label: 'Brokers', value: 'brokers' },
      { label: 'Load Scheduler', value: 'load-manager' },
      { label: 'Load Tracker', value: 'load-finder' },
      { label: 'Tracking', value: 'trucking' },
      { label: 'Communication Center', value: 'chat' },
      { label: 'Settings', value: 'settings' },
      { label: 'Load Entry', value: 'add-new-load' },
    ].map((module) => (
      <label key={module.value} className={styles.permissionLabel}>
        <input
          type="checkbox"
          checked={permissions.includes(module.value)}
          onChange={() => handlePermissionChange(module.value)}
        />
        {module.label}
      </label>
    ))}
  </div>

  {deleteTarget !== null && (
  <DeleteNotifications
    message={`Are you sure you want to delete ${deleteTarget.firstName} ${deleteTarget.lastName}'s account?`}
    onConfirm={confirmDeleteAccount}
    onCancel={() => setDeleteTarget(null)}
  />
)}

  <button type="button" onClick={selectedAccount ? handleUpdateAccount : handleCreateDispatcherOrAccounting} className={styles.submitButtonAccountsettings}>
    {selectedAccount ? 'Update Account' : 'Create Account'}
  </button>
  {selectedAccount && (
    <button type="button" onClick={clearAccountForm} className={styles.cancelButtonAccountsettings}>
      Cancel Edit
    </button>
  )}
</form>

<h3 className={styles.subtitleaccountsettings}>Existing Accounts</h3>
<div>
  {[...dispatchers, ...accountings].map((account) => (
    <div key={account._id} className={styles.accountItemsettings}>
      <p>{account.firstName} {account.lastName} - {account.role}</p>
      <button onClick={() => handleEditAccount(account)} className={styles.editButtonAccountnsettings}>Edit</button>
      <button onClick={() => requestDeleteAccount(account)} className={styles.deleteButtonAccountsettings}>
  Delete
</button>

    </div>
  ))}
</div>

<h3 className={styles.subtitlesettings}>Subscription</h3>
<p className={styles.blackTextsettings}>Subscription Type: {subscriptionInfo.subscriptionType}</p>
<p className={styles.blackTextsettings}>Expiration Date: {subscriptionInfo.contractEnd}</p>
<p className={styles.blackTextsettings}>Package: {subscriptionInfo.package}</p>


      <h3 className={styles.subtitleTwoFactorsettings}>Two-Factor Authentication</h3>
      {isTwoFactorEnabled ? (
        <div>
          <p style={{ color: 'green' }}>Two-Factor Authentication is Enabled</p>
          <button onClick={handleDisableTwoFactorAuth} className={styles.deleteButtonTwoFactorsettings}>
            Disable 2FA
          </button>
        </div>
      ) : (
        <div>
          <button onClick={handleEnableTwoFactorAuth} className={styles.submitButtonTwoFactorsettings}>
            Enable 2FA via Email
          </button>
        </div>
      )}

<button onClick={() => window.location.href = '/FaqPage'} className={styles.actionButtonfaqsettings}>
  FAQ
</button>

    </div>
  );
};



export default StandartPage;